// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

label {
  font-family: "Open Sans", sans-serif;
}

li {
  list-style: none;
}

::ng-deep#page-wrapper {
  padding-bottom: 60px;
}

::ng-deep#wrapper {
  overflow-x: initial;
}

::ng-deep.ideate-is .mainnav {
  display: flex;
  flex-wrap: wrap;
  margin: 30px 0 20px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.ideate-is .mainnav {
    margin: 10px 0 15px;
  }
}
::ng-deep.ideate-is .mainnav.mainnav--bottom {
  margin: 30px 0 40px;
}
::ng-deep.ideate-is .mainnav.mainnav--bottom ul li a {
  padding: 12px 30px;
  font-family: "Open Sans", sans-serif;
  font-weight: 700;
  font-size: 16px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.ideate-is .mainnav.mainnav--bottom ul li a {
    padding: 10px 20px;
    font-size: 14px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.ideate-is .mainnav.mainnav--bottom ul li a {
    padding: 9px;
    font-size: 11px;
  }
}
::ng-deep.ideate-is .mainnav.mainnav--bottom ul li.active a {
  background-color: #bbb !important;
  border-top: 1px solid #bbb !important;
  border-bottom: 1px solid #bbb !important;
}
::ng-deep.ideate-is .mainnav--editmode {
  margin: 0 0 15px;
}
::ng-deep.ideate-is .mainnav--editmode .mainnav__list {
  flex: 1;
  border-radius: 5px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.ideate-is .mainnav--editmode .mainnav__list {
    flex: none;
    width: 100%;
  }
}
::ng-deep.ideate-is .mainnav--editmode .mainnav__list li {
  width: 100%;
  flex: 1;
}
::ng-deep.ideate-is .mainnav--editmode .mainnav__list li a {
  width: 100%;
  padding: 5px 2px;
  text-align: center;
}
::ng-deep.ideate-is .mainnav__editmodeicon {
  margin-left: 5px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.ideate-is .mainnav__editmodeicon {
    margin: 10px 0 0 auto;
  }
}
::ng-deep.ideate-is .mainnav__editmodeicon ul {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  height: 100%;
}
::ng-deep.ideate-is .mainnav__editmodeicon ul li {
  list-style: none;
  transition: none;
  width: 37px;
  height: 100%;
  border-radius: 5px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: 1px solid #CFDBE2;
}
::ng-deep.ideate-is .mainnav__editmodeicon ul li.active {
  background-color: #676a6c;
}
::ng-deep.ideate-is .mainnav__editmodeicon ul li:not(:last-child) {
  margin-right: 5px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.ideate-is .mainnav__editmodeicon ul li:not(:last-child) {
    margin-right: 0;
  }
}
@media only screen and (max-width: 991px) {
  ::ng-deep.ideate-is .mainnav__editmodeicon ul li {
    width: 35px;
    height: 31px;
    display: none;
  }
}
::ng-deep.ideate-is .mainnav__editmodeicon ul li.mainnav__editmodepin {
  display: flex;
}
::ng-deep.ideate-is .mainnav__editmodeicon ul li.mainnav__editmodepin svg .st0 {
  fill: #FFFFFF;
}
::ng-deep.ideate-is .mainnav__editmodeicon ul li.mainnav__editmodepin svg .st1 {
  fill: #cfdbe2;
}
::ng-deep.ideate-is .mainnav__editmodeicon ul li.mainnav__editmodepin--pinactive svg .st0 {
  fill: #6d6e71;
}
::ng-deep.ideate-is .mainnav__editmodeicon ul li.mainnav__editmodepin--pinactive svg .st1 {
  fill: #FFFFFF;
}
::ng-deep.ideate-is .mainnav__editmodeicon ul li.listView svg .st0, ::ng-deep.ideate-is .mainnav__editmodeicon ul li.individualView svg .st0, ::ng-deep.ideate-is .mainnav__editmodeicon ul li.gridView svg .st0 {
  fill: #6d6e71;
}
::ng-deep.ideate-is .mainnav__editmodeicon ul li.listView svg .st1, ::ng-deep.ideate-is .mainnav__editmodeicon ul li.individualView svg .st1, ::ng-deep.ideate-is .mainnav__editmodeicon ul li.gridView svg .st1 {
  fill: #FFFFFF;
}
::ng-deep.ideate-is .stick-challenge {
  position: relative;
}
::ng-deep.ideate-is .stick-challenge .card-body__edit {
  min-height: auto;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 9;
  position: relative;
}
::ng-deep.ideate-is .stick-challenge .card-body__edit .card-body__subtitle {
  position: sticky;
  top: 0;
  z-index: 99;
  background-color: #fff;
}
::ng-deep.ideate-is .stick-challenge .card-body__inner {
  overflow-y: auto;
}
::ng-deep.ideate-is .info {
  color: #fff;
  border-color: rgb(255, 121, 0);
  margin-bottom: 18px;
  padding: 20px 40px;
  border-radius: 6px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.ideate-is .info {
    padding: 12px 20px;
  }
}
::ng-deep.ideate-is .info.infotitle {
  background-color: rgb(255, 121, 0);
}
::ng-deep.ideate-is .info h1 {
  font-size: 36px;
  font-weight: 500;
  margin: 0;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.ideate-is .info h1 {
    font-size: 28px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.ideate-is .info h1 {
    font-size: 24px;
  }
}
::ng-deep.ideate-is .info h1 .info__maintitle {
  margin-right: auto;
}
::ng-deep.ideate-is .info h1 small {
  color: #fff;
  font-size: 80%;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.ideate-is .info h1 small {
    width: 100%;
    margin-top: 5px;
  }
}
::ng-deep.ideate-is .info .card__toprow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 0 -15px;
}
::ng-deep.ideate-is .info .card__toprow--tne .card__topcol:first-child {
  width: 72% !important;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.ideate-is .info .card__toprow--tne .card__topcol:first-child {
    flex: 1;
    width: auto !important;
  }
}
::ng-deep.ideate-is .info .card__toprow .card__topcol {
  padding: 0 15px;
  width: 33.3333333333%;
}
::ng-deep.ideate-is .info .card__toprow .card__topcol--full {
  width: 100% !important;
}
::ng-deep.ideate-is .info .card__toprow .card__topcol:nth-child(1) {
  width: 28%;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.ideate-is .info .card__toprow .card__topcol:nth-child(1) {
    flex: 1;
    margin-right: auto;
  }
}
::ng-deep.ideate-is .info .card__toprow .card__topcol--tab {
  width: 44%;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.ideate-is .info .card__toprow .card__topcol--tab {
    width: 120px;
  }
}
::ng-deep.ideate-is .info .card__toprow .card__topcol--tt {
  width: 28%;
  margin-left: auto;
  text-align: right;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.ideate-is .info .card__toprow .card__topcol--tt {
    width: auto;
  }
}
::ng-deep.ideate-is .info .card__toprow .card__topcol--tt svg {
  max-width: 16px;
  cursor: pointer;
}
::ng-deep.ideate-is .info .card__toprow .card__topcol--tt .card__pinicon {
  position: absolute;
  right: -17px;
  top: -15px;
  width: 20px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.ideate-is .info .card__toprow .card__topcol--tt .card__pinicon {
    right: -1px;
    top: -10px;
  }
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--title {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--title > div:first-child {
  margin-right: 15px;
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--startexist {
  width: 65%;
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  border-radius: 3px;
  line-height: 1;
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li:first-child button svg {
  right: calc(100% + 1px);
}
@media only screen and (max-width: 630px) {
  ::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li:first-child button span.card__topcount {
    left: -30px;
  }
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li:last-child button svg {
  left: calc(100% + 1px);
}
@media only screen and (max-width: 630px) {
  ::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li:last-child button span.card__topcount {
    right: -30px;
  }
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li:not(:first-child) {
  margin-left: -1px;
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li:only-child button {
  border-radius: 3px;
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topactive button {
  color: rgb(255, 121, 0);
  border: 1px solid rgb(255, 121, 0);
  cursor: pointer;
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topactive button span.card__topcount {
  color: rgb(255, 121, 0);
  background-color: #efefef;
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topactive button span.card__topcount.redConverge_count {
  background-color: #EC2121;
  color: #fff;
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topcomplete button {
  opacity: 0.2;
  border: 1px solid rgb(255, 121, 0);
  color: rgb(255, 121, 0);
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topcomplete button span.card__topcount {
  color: rgb(255, 121, 0);
  background-color: #efefef;
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topcomplete button span.card__topcount.redConverge_count {
  background-color: #EC2121;
  color: #fff;
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li button {
  position: relative;
  color: rgb(105, 190, 40);
  font-size: 17px;
  padding: 6px 16px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  display: inline-block;
  height: 100%;
  border: 0;
  background-color: transparent;
  transition: all ease 0.3s;
  appearance: none;
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li button svg {
  position: absolute;
  top: -1px;
  height: calc(100% + 2px);
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li button svg .st0 {
  fill: rgb(255, 121, 0);
}
@media only screen and (max-width: 991px) {
  ::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li button {
    padding: 4px 6px;
    font-size: 13px;
  }
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li button:focus {
  outline: none;
  box-shadow: none;
}
@media only screen and (max-width: 1180px) {
  ::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > .card__topdesktext {
    display: none;
  }
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > .card__topmobiletext {
  display: none;
}
@media only screen and (max-width: 1180px) {
  ::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > .card__topmobiletext {
    display: inline-block;
  }
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > span.card__topcount {
  width: 16px;
  height: 16px;
  line-height: 16px;
  display: inline-block;
  text-align: center;
  font-size: 0.5em;
  background-color: rgb(255, 121, 0);
  color: #fff;
  margin-left: 4px;
  border-radius: 50%;
  vertical-align: bottom;
  position: relative;
  top: -1px;
}
@media only screen and (max-width: 630px) {
  ::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > span.card__topcount {
    position: absolute;
    top: auto;
    bottom: -2px;
    right: 0;
    margin: 0;
  }
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li button:hover {
  color: rgb(255, 121, 0);
  opacity: 1;
}
::ng-deep.ideate-is .info .card__toprow .card__topcol.card__topcol--tab ul li button:hover > span.card__topcount {
  color: rgb(255, 121, 0);
  background-color: #efefef;
  opacity: 1;
}
::ng-deep.ideate-is .info .card__toprow .card__topcol--ctt {
  position: relative;
}
::ng-deep.ideate-is .info .card__toprow .card__topcol--ctt ul li .card-body__tooltip {
  display: none;
  position: absolute;
  background: #fff;
  color: #676a6c;
  padding: 5px;
  top: -27px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
}
::ng-deep.ideate-is .info .card__toprow .card__topcol--ctt ul li button:hover {
  opacity: 0.2 !important;
}
::ng-deep.ideate-is .info .card__toprow .card__topcol--ctt ul li:hover .card-body__tooltip, ::ng-deep.ideate-is .info .card__toprow .card__topcol--ctt ul li:active .card-body__tooltip {
  display: block;
}
::ng-deep.ideate-is .info .card__toprow .card__h3button {
  border: 1px solid rgb(255, 121, 0);
  background-color: transparent;
  padding: 4px 26px;
  border-radius: 3px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  color: rgb(255, 121, 0);
  font-size: 22px;
  line-height: 1.2;
  transition: all ease 0.3s;
  cursor: pointer;
}
::ng-deep.ideate-is .info .card__toprow .card__h3button:hover {
  background-color: rgb(255, 121, 0);
  color: #fff;
}
::ng-deep.ideate-is .info .card__toprow .card__h3button:focus {
  outline: none;
}
::ng-deep.ideate-is .info .card__toprow .tooltipicon {
  cursor: pointer;
  position: relative;
  font-size: 18px;
  display: inline-block;
}
::ng-deep.ideate-is .info .card__toprow .tooltipicon i {
  color: rgb(255, 121, 0);
}
::ng-deep.ideate-is .info .card__toprow .tooltipicon:hover > i > .tooltiptext {
  visibility: visible;
}
::ng-deep.ideate-is .info .card__toprow .tooltipicon .tooltiptext {
  visibility: hidden;
  width: 250px;
  background-color: #fff;
  color: rgb(255, 121, 0);
  text-align: center;
  border-radius: 6px;
  padding: 10px;
  box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);
  font-size: 13px;
  font-family: "Open Sans", sans-serif;
  line-height: 1.5;
  position: absolute;
  top: 15px;
  right: 10px;
  z-index: 1;
}
::ng-deep.ideate-is .info h3 {
  font-size: 20px;
  margin: 0;
  cursor: pointer;
  color: rgb(255, 121, 0);
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.ideate-is .info h3 {
    font-size: 16px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.ideate-is .info h3 {
    font-size: 15px;
    word-break: break-word;
  }
}
::ng-deep.ideate-is .info h3 > *:not(:last-child) {
  margin-right: 5px;
}
::ng-deep.ideate-is .info h3 .card__bwnh3pencil a {
  color: rgb(255, 121, 0);
}
@media only screen and (max-width: 767px) {
  ::ng-deep.ideate-is .info h3 .card__bwnh3button {
    width: 100%;
    margin-top: 10px;
  }
}
::ng-deep.ideate-is .info h3 .card__bwnh3button button {
  font-size: 18px !important;
  padding-right: 15px !important;
  padding-left: 15px !important;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.ideate-is .info h3 .card__bwnh3button button {
    font-size: 16px !important;
  }
}
::ng-deep.ideate-is .info h3 i {
  cursor: pointer;
  font-size: 0.9em;
}
::ng-deep.ideate-is .info h3 i + div {
  padding-left: 7px;
}
::ng-deep.ideate-is .info h3 i + div span {
  display: block;
  font-size: 0.7em;
}
::ng-deep.ideate-is .info h3 i + span {
  padding-left: 7px;
}
::ng-deep.ideate-is .info .tooltipicon {
  position: relative;
  font-size: 18px;
  display: inline-block;
}
::ng-deep.ideate-is .info .tooltipicon i {
  color: rgb(255, 121, 0);
}
::ng-deep.ideate-is .info .tooltipicon:hover > i > .tooltiptext {
  visibility: visible;
}
::ng-deep.ideate-is .info .tooltipicon .tooltiptext {
  visibility: hidden;
  width: 250px;
  background-color: #fff;
  color: rgb(255, 121, 0);
  text-align: center;
  border-radius: 6px;
  padding: 10px;
  box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);
  font-size: 13px;
  font-family: "Open Sans", sans-serif;
  line-height: 1.5;
  position: absolute;
  top: 15px;
  right: 10px;
  z-index: 1;
}
::ng-deep.ideate-is app-ideate-ideas,
::ng-deep.ideate-is app-ideate-challenge-top-ideas {
  display: block;
  margin-top: 30px;
}
::ng-deep.ideate-is .card-default {
  border-radius: 6px;
  border-top-width: 3px;
  border: 0;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}
::ng-deep.ideate-is .card-default.card-default--summary {
  box-shadow: none;
}
::ng-deep.ideate-is .card-default.card-default--summary .info {
  border-top: 0;
  border-right: 0;
  border-left: 0;
  padding-right: 20px;
  padding-left: 20px;
}
::ng-deep.ideate-is .card-default.card-default--summary .card-body {
  border-right: 0;
  border-bottom: 0;
  border-left: 0;
  border-radius: 0;
}
::ng-deep.ideate-is .card-default.card-default--summary .card-body__inner {
  padding-right: 20px;
  padding-left: 20px;
}
::ng-deep.ideate-is .card-default.card-default--summary + div {
  margin-top: 20px;
}
::ng-deep.ideate-is .card-default + div {
  margin-top: 30px;
}
::ng-deep.ideate-is .card-default .info {
  margin: 0;
  border: 1px solid rgb(255, 121, 0);
  border-radius: 6px;
}
::ng-deep.ideate-is .card-default .info.card__headactive {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
::ng-deep.ideate-is .card-default .info.card__headactive--cc {
  background-color: rgb(255, 121, 0);
}
::ng-deep.ideate-is .card-default .info.card__headactive--cc .card__topcol h3 {
  color: #fff;
}
::ng-deep.ideate-is .card-default .info.card__headactive--cc .card__topcol ul li button {
  border-color: #fff;
  background-color: #fff;
}
::ng-deep.ideate-is .card-default .info.card__headactive--cc .card__topcol ul li button span {
  color: rgb(255, 121, 0);
  background-color: #fff;
}
::ng-deep.ideate-is .card-default .info.card__headactive--cc .card__topcol ul li button .st0 {
  fill: #fff !important;
}
::ng-deep.ideate-is .card-default .info.card__headactive--cc i {
  color: #fff;
}
::ng-deep.ideate-is .card-default .card-body__inner {
  padding: 15px 40px;
  height: auto;
  overflow-y: auto;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.ideate-is .card-default .card-body__inner {
    padding: 12px 20px;
  }
}
::ng-deep.ideate-is .card-default .card-body {
  display: none;
  border: 1px solid #CFDBE2;
  border-top: 0;
  border-radius: 0 0 6px 6px;
  overflow: hidden;
}
::ng-deep.ideate-is .card-default .card-body.card-show {
  display: block;
}
::ng-deep.ideate-is .card-default .card-body.card-show__wbg {
  background-color: #fff;
}
::ng-deep.ideate-is .card-default .card-body .hideblk {
  display: none;
}
::ng-deep.ideate-is .card-default .card-body__finalstate p {
  font-size: 15px;
  font-weight: 600;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.ideate-is .card-default .card-body__finalstate p {
    font-size: 13px;
  }
}
::ng-deep.ideate-is .card-default .card-body__finalstate p:last-child {
  margin-bottom: 0;
}
::ng-deep.ideate-is .card-default .card-body__finalstate--2 {
  margin: 0 -10px;
}
::ng-deep.ideate-is .card-default .card-body__finalstate--2 > div {
  width: 50%;
  padding: 0 10px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.ideate-is .card-default .card-body__finalstate--2 > div {
    width: 100%;
  }
}
::ng-deep.ideate-is .card-default .card-body__finalstate--2 > div p {
  position: relative;
  padding-left: 10px;
}
::ng-deep.ideate-is .card-default .card-body__finalstate--2 > div p::before {
  content: "";
  position: absolute;
  top: 8px;
  left: 0;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #444;
}
::ng-deep.ideate-is .card-default .card-body__subtitle {
  padding-left: 35px;
  margin-bottom: 16px;
  position: relative;
}
::ng-deep.ideate-is .card-default .card-body__subtitle *:last-child {
  margin-bottom: 0;
}
::ng-deep.ideate-is .card-default .card-body__subtitle > span {
  position: absolute;
  top: 0;
  right: 2px;
  opacity: 0.7;
  cursor: pointer;
}
::ng-deep.ideate-is .card-default .card-body__subtitle > span.thinkeyebtn {
  right: 0px;
}
::ng-deep.ideate-is .card-default .card-body__subtitle--pl0 {
  padding-left: 0;
}
::ng-deep.ideate-is .card-default .card-body__subtitle p {
  color: #969798;
  font-size: 15px;
}
::ng-deep.ideate-is .card-default .card-body__subtitle p i {
  padding-left: 5px;
}
::ng-deep.ideate-is .card-default .c-radio label {
  padding-left: 0;
}
::ng-deep.ideate-is .card-default .c-radio input {
  opacity: 0;
  margin: 0;
}
::ng-deep.ideate-is .card-default .c-radio input + span {
  position: relative;
  display: inline-block;
  vertical-align: top;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #ccc;
  margin-right: 5px;
  text-align: center;
}
::ng-deep.ideate-is .card-default .c-radio input + span::before {
  position: absolute;
  color: rgb(255, 121, 0);
  opacity: 0;
  font-size: 11px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
::ng-deep.ideate-is .card-default .c-radio input:checked + span {
  border-color: rgb(255, 121, 0);
}
::ng-deep.ideate-is .card-default .c-radio input:checked + span::before {
  opacity: 1;
}
::ng-deep.ideate-is .card-default .checkbox {
  margin-top: 0;
}
::ng-deep.ideate-is .card-default .checkbox label {
  min-height: 20px;
  padding-left: 0;
  margin-bottom: 0;
  font-weight: 400;
  cursor: pointer;
  width: 100% !important;
  font-size: 15px;
  font-weight: bold;
  color: #676a6c;
}
::ng-deep.ideate-is .card-default .checkbox label > i {
  position: relative;
  top: 1px;
  margin-right: 6px;
}
::ng-deep.ideate-is .card-default .checkbox label > span {
  vertical-align: middle;
}
::ng-deep.ideate-is .card-default .checkbox input {
  opacity: 0;
  position: absolute;
  display: none;
}
::ng-deep.ideate-is .card-default .checkbox input + span {
  position: relative;
  display: inline-block;
  vertical-align: top;
  width: 20px;
  height: 20px;
  border-radius: 2px;
  border: 1px solid #ccc;
  margin-right: 10px;
  text-align: center;
  vertical-align: middle;
}
::ng-deep.ideate-is .card-default .checkbox input + span::before {
  font-size: 12px;
  position: absolute;
  color: #fff;
  opacity: 0;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
::ng-deep.ideate-is .card-default .checkbox input:checked + span {
  border-color: rgb(255, 121, 0);
  background-color: rgb(255, 121, 0);
}
::ng-deep.ideate-is .card-default .checkbox input:checked + span::before {
  opacity: 1;
}
::ng-deep.ideate-is .card-default .card-body__button {
  background-color: #f5f5f5;
  border-top: 1px solid #e3e3e3;
  padding: 12px 40px;
}
::ng-deep.ideate-is .card-default .card-body__button .card-button {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
::ng-deep.ideate-is .card-default .card-body__button .card-button .btn {
  border-radius: 3px;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  transition: all ease 0.3s;
}
::ng-deep.ideate-is .card-default .card-body__button .card-button .btn + .btn {
  margin-left: 15px;
}
::ng-deep.ideate-is .card-default .card-body__button .card-button .btn em {
  margin-right: 6px;
  font-size: 0.8em;
}
::ng-deep.ideate-is .card-default .card-body__button .card-button .float-right {
  margin-left: auto;
}
::ng-deep.ideate-is .card-default .card-body__button .card-button .btn-ideate {
  background-color: rgb(255, 121, 0);
  border-color: rgb(255, 121, 0);
  color: #fff;
}
::ng-deep.ideate-is .card-default .card-body__button .card-button .btn-ideate:hover {
  background-color: rgb(255, 121, 0);
  border-color: rgb(255, 121, 0);
}
::ng-deep.ideate-is .card-default .card-body__button .card-button .btn-success {
  background-color: #27c24c;
  border-color: #27c24c;
}
::ng-deep.ideate-is .card-default .card-body__button .card-button .btn-success:hover {
  background-color: #21A240;
  border-color: #1E983B;
}
::ng-deep.ideate-is .card-default .card-body__button .card-button .btn-danger {
  background-color: #fff;
  border-color: #fff;
  color: #ef6272;
}
::ng-deep.ideate-is .card-default .card-body__button .card-button .btn-danger:hover {
  background-color: #ED2D2D;
  border-color: #EC2121;
}
::ng-deep.ideate-is .card-default .card-body__button .card-button .btn-warning em {
  margin: 0;
}
::ng-deep.ideate-is .card-default .card-body__button .card-button .btn-deleteall {
  border: 0;
  background-color: transparent;
  position: relative;
  overflow: hidden;
  box-shadow: none;
  padding-right: 0;
  padding-left: 0;
  transition: all ease 0.3s;
}
::ng-deep.ideate-is .card-default .card-body__button .card-button .btn-deleteall span {
  position: absolute;
  left: 110%;
  transition: all ease 0.3s;
}
::ng-deep.ideate-is .card-default .card-body__button .card-button .btn-deleteall:hover {
  background-color: #fff;
  color: #ed5562;
  padding-right: 16px;
  padding-left: 16px;
}
::ng-deep.ideate-is .card-default .card-body__button .card-button .btn-deleteall:hover > span {
  position: relative;
  left: 0;
}
::ng-deep.ideate-is .card-default .card-body__button .card-button .btn-deleteall:hover em {
  margin-right: 6px;
}
::ng-deep.ideate-is .card-default .card-body__button .card-button .btn-deleteall em {
  font-size: 1em;
  margin-right: 0;
  transition: all ease 0.3s;
}
::ng-deep.ideate-is .card-default .card-body--ebtn {
  margin-top: 15px;
  padding: 15px 40px;
  border-top: 1px solid #CFDBE2;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.ideate-is .card-default .card-body--ebtn {
    padding: 12px 20px;
  }
}
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow {
  margin: 0 -8px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow > div {
  padding: 0 8px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow > div {
    width: 100%;
    text-align: center;
  }
  ::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow > div + div {
    margin-top: 10px;
  }
}
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow > div.card-body--col--last {
  margin-left: auto;
}
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn {
  border-radius: 3px;
  font-size: 14px;
  font-weight: bold;
  padding: 7px 16px;
  text-align: center;
  transition: all ease 0.3s;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn {
    font-size: 12px;
  }
}
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn i,
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn em {
  margin-right: 6px;
  font-size: 0.8em;
}
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--save {
  background-color: rgb(105, 190, 40);
  color: #fff;
}
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--clarify {
  background-color: rgb(0, 173, 208);
  color: #fff;
}
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--ideate {
  background-color: rgb(255, 121, 0);
  color: #fff;
  border-color: rgb(255, 121, 0);
  font-weight: 900;
}
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--disable {
  opacity: 0.5;
}
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--tracking {
  background-color: #6d6e71;
  color: #fff;
  border-color: #6d6e71;
}
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--cancel {
  padding: 0;
  background-color: transparent;
  margin-left: 0;
  color: #676a6c;
  border: 0;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  font-weight: 700;
}
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--cancel:hover {
  color: #000;
}
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--tracking {
  background-color: #6d6e71;
  color: #fff;
}
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--converge {
  padding: 0 8px;
}
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall {
  border: 0;
  background-color: transparent;
  position: relative;
  overflow: hidden;
  box-shadow: none;
  padding-right: 0;
  padding-left: 0;
  transition: all ease 0.3s;
}
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall i {
  font-size: 14px;
  color: #676a6c;
}
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall span {
  position: absolute;
  left: 110%;
  transition: all ease 0.3s;
}
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall:hover {
  background-color: #f5f5f5;
  color: #ed5562;
  padding-right: 16px;
  padding-left: 16px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall:hover {
    padding-right: 7px;
    padding-left: 7px;
  }
}
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall:hover > span {
  position: relative;
  left: 0;
}
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall:hover em {
  margin-right: 6px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall {
    background-color: #f5f5f5;
    color: #ed5562;
    padding-right: 16px;
    padding-left: 16px;
  }
}
@media only screen and (max-width: 767px) and (max-width: 767px) {
  ::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall {
    padding-right: 7px;
    padding-left: 7px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall > span {
    position: relative;
    left: 0;
  }
  ::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall em {
    margin-right: 6px !important;
  }
}
::ng-deep.ideate-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall em {
  font-size: 1em;
  margin-right: 0;
  transition: all ease 0.3s;
}
::ng-deep.ideate-is .card-default .note-3 {
  padding: 15px 15px 10px;
  border: 2px solid rgb(255, 121, 0);
  margin-bottom: 15px;
}
::ng-deep.ideate-is .card-default .note-3 label {
  color: rgb(255, 121, 0);
}
::ng-deep.ideate-is .card-default .footer-line {
  color: rgb(255, 121, 0);
}
::ng-deep.ideate-is .card-default p {
  font-size: 15px;
}
::ng-deep.ideate-is .card-default p:last-child {
  margin-bottom: 0;
}
::ng-deep.ideate-is .card-default .card-body__edit {
  position: relative;
}
::ng-deep.ideate-is .card-default .card-body__edit .breakthrough-input-tabs,
::ng-deep.ideate-is .card-default .card-body__edit .brainstorm-input-tabs {
  width: 100%;
  margin-right: 0;
  position: relative;
}
::ng-deep.ideate-is .card-default .card-body__edit .breakthrough-input-tabs input,
::ng-deep.ideate-is .card-default .card-body__edit .breakthrough-input-tabs select,
::ng-deep.ideate-is .card-default .card-body__edit .brainstorm-input-tabs input,
::ng-deep.ideate-is .card-default .card-body__edit .brainstorm-input-tabs select {
  height: 45px;
  padding: 5px 15px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 15px;
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow {
  margin: 0 -15px;
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow > div {
  padding: 0 15px;
  width: 100%;
  margin-bottom: 15px;
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow > div > div {
  position: relative;
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .proposed-challenge {
  margin-top: 10px;
  font-family: "Open Sans", sans-serif;
  font-size: 15px;
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .proposed-challenge label {
  padding-bottom: 4px;
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow select {
  appearance: none;
  background-image: url("https://assets.foursightonline.com/app/images/select.png");
  background-size: 10px;
  background-position: right 10px center;
  background-repeat: no-repeat;
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow textarea {
  width: 100%;
  border: 1px solid #ccc;
  resize: none;
  border-radius: 3px;
  padding: 10px 15px;
  font-size: 15px;
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs,
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs {
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editlabel,
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editlabel {
  width: 35px;
  padding-right: 15px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber,
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber {
  width: 40px;
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  border-right: 0;
  border-radius: 4px 0 0 4px;
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput,
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput {
  width: calc(100% - 41px);
  padding-right: 60px;
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput--ce,
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput--ce {
  position: relative;
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput--ce .converge-icon,
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput--ce .converge-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 7px;
  font-size: 26px;
  color: rgb(255, 121, 0);
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput--ce .converge-icon:hover > .card-body__tooltip, ::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput--ce .converge-icon:active > .card-body__tooltip,
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput--ce .converge-icon:hover > .card-body__tooltip,
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput--ce .converge-icon:active > .card-body__tooltip {
  display: block;
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput--ce .converge-icon .card-body__tooltip,
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput--ce .converge-icon .card-body__tooltip {
  display: none;
  font-size: 16px;
  color: #676a6c;
  position: absolute;
  bottom: 100%;
  left: 0;
  background: #fff;
  padding: 5px;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  width: max-content;
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput--ce input,
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput--ce input {
  padding-left: 26px;
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber label,
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber label {
  font-weight: 900;
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editselect,
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editselect {
  width: 315px;
  padding-right: 15px;
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput,
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput {
  width: calc(100% - 351px);
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput input,
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput input {
  padding-right: 70px;
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput input:focus, ::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput input:focus-visible,
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput input:focus,
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput input:focus-visible {
  outline: none;
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput .card-body__minus--hide,
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput .card-body__minus--hide {
  display: none;
}
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput:only-child,
::ng-deep.ideate-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput:only-child {
  width: 100%;
}
::ng-deep.ideate-is .card-default .card-body__edit + .card-body__addnew button {
  margin: 0 39px;
  font-size: 14px;
  font-weight: bold;
  background-color: transparent;
  border: 1px solid transparent;
  padding-right: 0;
  padding-left: 0;
  color: #676a6c;
  transition: all ease 0.3s;
}
::ng-deep.ideate-is .card-default .card-body__edit + .card-body__addnew button:hover {
  background-color: rgb(255, 121, 0);
  border: 1px solid rgb(255, 121, 0);
  color: #fff;
  padding-right: 12px;
  padding-left: 12px;
}
::ng-deep.ideate-is .card-default .input-tabs {
  display: inline-flex;
  align-items: center;
  width: 100%;
  padding: 0 0 0 0;
  margin: 0;
}
::ng-deep.ideate-is .card-default .input-tabs + i {
  position: relative;
  top: -1px;
}
::ng-deep.ideate-is .card-default .input-tabs .select_faded {
  opacity: 0.2;
  padding-left: 32px;
}
::ng-deep.ideate-is .card-default .input-tabs input,
::ng-deep.ideate-is .card-default .input-tabs select {
  height: 45px;
  padding: 5px 15px;
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  margin: 7px 0px;
}
::ng-deep.ideate-is .card-default .input-tabs label {
  width: 20px;
  margin: 0;
}
::ng-deep.ideate-is .card-default .input-tabs select {
  width: 9%;
}
::ng-deep.ideate-is .card-default .input-tabs input {
  width: 90%;
  margin-left: 15px;
}
::ng-deep.ideate-is .card-default .input-group-text {
  cursor: pointer;
  padding: 3px 16px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.528571429;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #E9ECEF;
  border: 1px solid #DDE6E9;
  border-radius: 0.25rem;
  position: absolute;
  top: calc(50% + 1px);
  right: 0;
  transform: translateY(-50%);
  transition: all ease 0.3s;
}
::ng-deep.ideate-is .card-default .input-group-text:hover {
  background-color: rgb(255, 121, 0);
  border-color: rgb(255, 121, 0);
  color: #fff;
}
::ng-deep.ideate-is .card-default .list-columns {
  display: flex;
  flex-wrap: wrap;
  counter-reset: section;
}
::ng-deep.ideate-is .card-default .list-columns > div.card__body--cswrapper {
  width: 100%;
  position: relative;
  border-bottom: 1px solid #e4e4e4;
  padding-bottom: 5px;
  margin-bottom: 10px;
}
::ng-deep.ideate-is .card-default .list-columns > div.card__body--cswrapper::before, ::ng-deep.ideate-is .card-default .list-columns > div.card__body--cswrapper::after {
  content: "";
  position: absolute;
  bottom: -1px;
  right: 100%;
  width: 40px;
  height: 1px;
  background-color: #e4e4e4;
}
::ng-deep.ideate-is .card-default .list-columns > div.card__body--cswrapper::after {
  right: auto;
  left: 100%;
}
::ng-deep.ideate-is .card-default .list-columns.list-columns--2 > div {
  width: 100%;
}
::ng-deep.ideate-is .card-default .list-columns .brainstorm-tabs {
  position: relative;
  padding-left: 23px;
}
::ng-deep.ideate-is .card-default .list-columns .brainstorm-tabs::before {
  counter-increment: section;
  content: counter(section) ".";
  position: absolute;
  top: 0;
  left: 0;
}
::ng-deep.ideate-is .idea-shop-list {
  padding: 20px;
  margin-left: 17px;
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.ideate-is .idea-shop-list li {
  width: 50%;
  margin-bottom: 10px;
}
::ng-deep.ideate-is .brainstorm__col {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 17px;
}
::ng-deep.ideate-is .brainstorm__col .brainstorm-main {
  width: calc(100% - 68px);
  display: inline-block;
  margin-right: 20px;
}
::ng-deep.ideate-is .brainstorm__col .brainstorm-main .brainstorm-group {
  width: 100%;
  position: relative;
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.ideate-is .brainstorm__col .brainstorm-main .brainstorm-group .input-group-prepend {
  margin-right: -1px;
  width: 45px;
}
::ng-deep.ideate-is .brainstorm__col .brainstorm-main .brainstorm-group .input-group-prepend .input-group-text {
  background: transparent;
  border-color: rgb(255, 121, 0);
  height: 35px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
::ng-deep.ideate-is .brainstorm__col .brainstorm-main .brainstorm-group input {
  width: calc(100% - 45px);
  height: 35px;
  border: 1px solid rgb(255, 121, 0);
  border-radius: 0 0.25rem 0.25rem 0;
}
::ng-deep.ideate-is .card-bottom-button .button {
  font-size: 13px;
  color: #fff;
  padding: 8px 10px;
  border-radius: 3px;
  transition: all ease 0.3s;
}
::ng-deep.ideate-is .card-bottom-button .button:hover {
  opacity: 0.8;
}
::ng-deep.ideate-is .card-bottom-button .button i {
  font-size: 0.8em;
}
::ng-deep.ideate-is .card-bottom-button .button.btn-clarify {
  background-color: rgb(0, 173, 208);
}
::ng-deep.ideate-is .card-bottom-button .button.btn-ideate {
  background-color: rgb(255, 121, 0);
}
::ng-deep.ideate-is .card-bottom-button .button.btn-implement {
  background-color: rgb(245, 67, 89);
}
::ng-deep.ideate-is .dotactions {
  position: relative;
}
::ng-deep.ideate-is .dotactions .dotactions__inner {
  position: absolute;
  top: 0;
  right: 0;
}
::ng-deep.ideate-is .dotactions .dotactions__inner--h {
  top: 5px;
}
::ng-deep.ideate-is .dotactions .dotactions__inner--h .dotactions__top {
  cursor: pointer;
  width: 17px;
  justify-content: space-between;
}
::ng-deep.ideate-is .dotactions .dotactions__inner--v {
  right: 10px;
  top: 11px;
}
::ng-deep.ideate-is .dotactions .dotactions__inner--v .dotactions__top {
  cursor: pointer;
  flex-direction: column;
  justify-content: space-between;
  height: 21px;
  width: 11px;
  align-items: center;
}
::ng-deep.ideate-is .dotactions .dotactions__inner .dotactions__top {
  padding-bottom: 4px;
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.ideate-is .dotactions .dotactions__inner .dotactions__top span {
  background-color: #adadad;
  width: 3px;
  height: 3px;
  border-radius: 50%;
}
::ng-deep.ideate-is .dotactions .dotactions__inner .dotactions__dropdown {
  display: none;
  background-color: #fff;
  position: absolute;
  top: 100%;
  width: 150px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.04);
  right: -5px;
  border-radius: 4px;
  z-index: 9;
  border: 1px solid #ddd;
}
::ng-deep.ideate-is .dotactions .dotactions__inner .dotactions__dropdown .dotactions__close {
  cursor: pointer;
  position: absolute;
  top: 5px;
  right: 6px;
  font-size: 11px;
  transition: all ease 0.3s;
}
::ng-deep.ideate-is .dotactions .dotactions__inner .dotactions__dropdown .dotactions__close:hover {
  transform: rotate(360deg);
}
::ng-deep.ideate-is .dotactions .dotactions__inner .dotactions__dropdown .dotactions__dropdowninner {
  display: none;
  position: absolute;
  top: 0;
  right: 0;
  width: 200px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.04);
  border-radius: 4px;
  padding: 18px;
  background: #fff;
  border: 1px solid #ddd;
}
::ng-deep.ideate-is .dotactions .dotactions__inner .dotactions__dropdown .dotactions__dropdowninner .dotactions__dropdownin {
  padding: 10px 10px;
  border-radius: 4px;
  min-height: 100%;
  background-color: #f4f4f4;
}
::ng-deep.ideate-is .dotactions .dotactions__inner .dotactions__dropdown .dotactions__dropdowninner .dotactions__dropdownin h6 {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 6px;
}
::ng-deep.ideate-is .dotactions .dotactions__inner .dotactions__dropdown > h6 {
  text-align: center;
  margin: 0;
  font-size: 13px;
  padding: 8px 10px;
  border-bottom: 1px solid #eee;
  font-weight: 400;
  margin-bottom: 2px;
  background-color: #f4f4f4;
}
::ng-deep.ideate-is .dotactions .dotactions__inner .dotactions__dropdown li {
  margin: 0;
}
::ng-deep.ideate-is .dotactions .dotactions__inner .dotactions__dropdown li a {
  padding: 6px 12px;
  color: #656565;
  display: block;
  font-weight: 400;
}
::ng-deep.ideate-is .dotactions .dotactions__inner .dotactions__dropdown li a:hover {
  background-color: rgba(9, 30, 66, 0.04);
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap {
  padding: 4px 0 80px;
  overflow-x: auto;
  margin: 0 0 10px;
  display: flex;
  flex-wrap: nowrap;
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap .card-body__ipcol {
  padding: 0;
  margin-bottom: 0px;
  max-width: 285px;
  width: 100%;
  flex: 0 0 285px;
  -webkit-flex: 0 0 285px;
  -ms-flex: 0 0 285px;
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap .card-body__ipcol .checkbox {
  padding-right: 22px;
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap .card-body__ipcol + div {
  margin-left: 30px;
}
@media only screen and (max-width: 1080px) {
  ::ng-deep.ideate-is .card-body__ip .card-body__ipwrap .card-body__ipcol {
    width: 50%;
  }
}
@media only screen and (max-width: 600px) {
  ::ng-deep.ideate-is .card-body__ip .card-body__ipwrap .card-body__ipcol {
    width: 100%;
  }
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap .card-body__ipcol .card-body__ipaddcol {
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap .card-body__ipcol .card-body__ipaddcol > .form-control {
  width: calc(100% - 91px);
  border: 1px solid #ccc;
  border-radius: 4px 0 0 4px;
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap .card-body__ipcol .card-body__ipaddcol .input-group-postpend {
  width: 90px;
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap .card-body__ipcol .card-body__ipaddcol .input-group-postpend button {
  background-color: rgb(255, 121, 0);
  box-shadow: none;
  color: #fff;
  border-color: rgb(255, 121, 0);
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap .card-body__ipcol .card-body__ipaddcol .input-group-postpend--ro {
  opacity: 0.4;
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap h2 {
  margin-top: 0;
  color: #656565;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 12px;
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap h2 label {
  display: inline-block;
  padding-right: 2px;
  width: auto !important;
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap h2 input[type=checkbox] {
  opacity: 0;
  position: absolute;
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap h2 input[type=checkbox] + span {
  position: relative;
  top: -2px;
  margin: 0 5px 0 0;
  display: inline-block;
  vertical-align: top;
  width: 20px;
  height: 20px;
  border-radius: 2px;
  border: 1px solid #ccc;
  text-align: center;
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap h2 input[type=checkbox] + span::before {
  position: absolute;
  color: #fff;
  opacity: 0;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap h2 input[type=checkbox]:checked + span {
  background-color: rgb(255, 121, 0);
  border-color: rgb(255, 121, 0);
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap h2 input[type=checkbox]:checked + span::before {
  opacity: 1;
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap .dotactions__editinput {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap .dotactions__editinput > div:first-child {
  margin-right: 10px;
  width: 73%;
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap .dotactions__editinput > div:first-child input:focus {
  border-color: rgb(255, 121, 0);
  outline: rgb(255, 121, 0);
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap .dotactions__editinput > div:nth-child(2) {
  margin-left: auto;
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap .dotactions__editinput > div:nth-child(3) {
  margin-left: 10px;
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap .dotactions__editinput > div i {
  font-size: 17px;
  color: #ff0000;
  cursor: pointer;
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap .dotactions__editinput .topidea__btn {
  padding: 3px 5px;
  font-size: 12px;
  color: #fff;
  background-color: rgb(105, 190, 40);
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap ul {
  padding: 0;
  margin: 0;
  min-height: 10px;
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap ul li {
  list-style: none;
  padding: 0;
  width: 100%;
}
::ng-deep.ideate-is .card-body__ip .card-body__ipwrap ul li .card-body__ipinner {
  display: block;
  font-weight: 400;
  position: relative;
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 5px;
}

.tooltippopup {
  max-width: 360px;
  width: 100%;
  height: 100%;
  background: #fff;
  position: fixed;
  top: 0;
  right: -550px;
  padding: 45px 24px 24px;
  text-align: left;
  z-index: 9999;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
  transition: all ease 0.3s;
  overflow-y: auto;
}
.tooltippopup--active {
  right: 0;
}
.tooltippopup--videoexist {
  max-width: 735px;
}
.tooltippopup__btn {
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  margin: 0 0 10px;
}
.tooltippopup__btn li {
  list-style: none;
  text-align: center;
  cursor: pointer;
  width: 33.3333333333%;
}
.tooltippopup__btn li button {
  width: 100%;
  color: rgb(255, 121, 0);
  font-size: 12px;
  padding: 6px 16px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  display: inline-block;
  height: 100%;
  border: 0;
  border: 1px solid rgb(255, 121, 0);
  background-color: transparent;
  transition: all ease 0.3s;
  appearance: none;
}
.tooltippopup__btn li button:focus {
  outline: none;
}
.tooltippopup__btn li button.tooltippopup__btncompleted {
  opacity: 0.2;
}
.tooltippopup__btn li button.tooltippopup__btncompleted:hover {
  opacity: 1;
}
.tooltippopup__btn li button.tooltippopup__btnactive {
  opacity: 1;
}
.tooltippopup__btn li button:hover {
  position: relative;
  z-index: 9;
}
.tooltippopup__btn li + li {
  margin-left: -1px;
}
.tooltippopup__btn li:first-child button {
  border-radius: 3px 0 0 3px;
}
.tooltippopup__btn li:last-child button {
  border-radius: 0 3px 3px 0;
}
.tooltippopup h4 {
  color: #676a6c;
  margin: 0 0 10px;
  font-size: 16px;
  line-height: 1.2;
}
.tooltippopup p {
  color: #676a6c;
  margin: 0 0 10px;
  font-size: 14px;
  line-height: 1.4;
}
.tooltippopup__close {
  position: absolute;
  top: 10px;
  right: 25px;
  width: 18px;
  height: 18px;
  cursor: pointer;
  transition: all ease 0.3s;
}
.tooltippopup__close:hover {
  transform: rotate(360deg);
}
.tooltippopup__close > div {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transform: rotate(45deg);
}
.tooltippopup__close > div span {
  position: absolute;
  background: #676a6c;
}
.tooltippopup__close > div span:nth-child(1) {
  top: 0;
  left: calc(50% - 1px);
  width: 2px;
  height: 100%;
}
.tooltippopup__close > div span:nth-child(2) {
  top: calc(50% - 1px);
  left: 0;
  width: 100%;
  height: 2px;
}
.tooltippopup__child {
  margin-top: 20px;
}
.tooltippopup__childdata .table-responsive {
  overflow-x: auto;
  margin-bottom: 10px;
}
.tooltippopup__childdata .table-responsive table {
  min-width: 297px;
  border: 1px solid #e7eaec;
}
.tooltippopup__childdata .table-responsive table th,
.tooltippopup__childdata .table-responsive table td {
  border: 1px solid #e7eaec;
  min-width: 120px;
}
.tooltippopup__childdata .table-responsive + * {
  margin-top: 20px;
}
.tooltippopup__childdata--clarify h4 {
  color: rgb(0, 173, 208);
}
.tooltippopup__childdata--ideate h4 {
  color: rgb(255, 121, 0);
}
.tooltippopup__childdata--develop h4 {
  color: rgb(105, 190, 40);
}
.tooltippopup__childdata--implement h4 {
  color: rgb(245, 67, 89);
}
.tooltippopup__childdata h4 {
  font-size: 16px;
  font-weight: 500;
  margin: 0 0 2px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
}
.tooltippopup__childdata h4 + h5 {
  mask-type: 10px;
}
.tooltippopup__childdata p {
  margin-bottom: 5px;
  line-height: 1.3;
}
.tooltippopup__childdata p:last-child {
  margin-bottom: 0;
}
.tooltippopup__childdata + div {
  margin-top: 17px;
}
.tooltippopup__links {
  padding: 0;
  margin: 0;
}
.tooltippopup__links li {
  list-style: none;
  width: 100%;
}
.tooltippopup__links li a {
  position: relative;
  color: rgb(255, 121, 0);
  transition: all ease 0.3s;
}
.tooltippopup__links li a:hover {
  opacity: 0.75;
}
.tooltippopup__links li + li {
  margin-top: 4px;
}

.popaccordian__rowhead {
  position: relative;
  cursor: pointer;
  border: 1px solid rgb(255, 121, 0);
  padding: 9px;
  border-radius: 3px;
  display: flex;
  flex-wrap: wrap;
}
.popaccordian__rowheadarrow {
  position: absolute;
  top: 0;
  left: 0;
}
.popaccordian__rowhead h5 {
  margin: 0;
  position: relative;
  color: rgb(255, 121, 0);
  padding-left: 10px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
}
.popaccordian__rowhead h5 i {
  transition: all ease 0.3s;
}
.popaccordian__rowbody {
  border: 1px solid rgb(255, 121, 0);
  border-top: 0;
  display: none;
  border-radius: 0 0 3px 3px;
}
.popaccordian__rowbodyinner {
  padding: 10px;
}
.popaccordian__rowbodyinner > *:last-child {
  margin-bottom: 0;
}
.popaccordian__rowbodyinner h5 {
  margin: 0 0 10px;
  position: relative;
  color: rgb(255, 121, 0);
  font-family: "Museo-700" !important;
  font-weight: normal !important;
}
.popaccordian__rowbodyinner ul {
  margin: 0;
  padding: 0;
}
.popaccordian__rowbodyinner ul li {
  list-style: none;
  font-size: 14px;
  line-height: 1.3;
  position: relative;
  padding-left: 10px;
}
.popaccordian__rowbodyinner ul li::before {
  content: "";
  position: absolute;
  top: 7px;
  left: 0;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #444;
}
.popaccordian__rowbodyinner ul li + li {
  margin-top: 5px;
}
.popaccordian__rowvideo {
  margin-top: 20px;
  padding-bottom: 15px;
}
.popaccordian__rowvideoinner {
  position: relative;
}
.popaccordian__rowvideoinner iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100% !important;
  height: 100% !important;
}
.popaccordian__row + div {
  margin-top: 15px;
}
.popaccordian__row .popaccordian__rowhead {
  align-items: center;
  justify-content: space-between;
}
.popaccordian__row--active .popaccordian__rowhead {
  border-radius: 3px 3px 0 0;
}
.popaccordian__row--active .popaccordian__rowhead i {
  transform: rotate(90deg);
}
.popaccordian__row:first-child .popaccordian__rowbody {
  display: block;
}
.popaccordian__gen .slctrs {
  border-bottom: 1.5px solid #F1F1F2;
}
.popaccordian__gen select {
  width: 100%;
  border: 1px solid #CFDBE2;
  padding: 6px;
  height: 45px;
  border-radius: 4px;
}
.popaccordian__gen label {
  display: block;
}
.popaccordian__gen button {
  background-color: rgb(255, 121, 0);
  border-color: rgb(255, 121, 0);
}
.popaccordian__gen__aidata {
  min-height: 400px;
  position: relative;
  display: none;
}
.popaccordian__gen__aidata--hyt {
  min-height: auto;
}
.popaccordian__gen__addbtn button {
  background-color: transparent;
  border: 0;
}
.popaccordian__gen__addbtn button:active {
  box-shadow: none;
}

.prevnext {
  padding: 20px 0;
}
.prevnext__inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 0;
  margin: 0;
}
.prevnext li {
  list-style: none;
}
.prevnext li.prevnext__next {
  margin-left: auto;
}
.prevnext li.prevnext__prev a:hover > i {
  left: -5px;
}
.prevnext li.prevnext__next a {
  background-color: rgb(255, 121, 0);
  color: #fff;
  opacity: 1;
  padding: 6px 12px;
  border-radius: 3px;
}
.prevnext li.prevnext__next a:hover > i {
  left: 3px;
}
.prevnext li a {
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  font-size: 14px;
  color: #676a6c;
  opacity: 0.47;
  padding: 6px 0;
  display: inline-block;
  transition: all ease 0.3s;
}
.prevnext li a i {
  position: relative;
  font-size: 1.1em;
  left: 0;
  transition: all ease 0.3s;
}

.playbtn {
  position: absolute;
  right: 9px;
  bottom: 7px;
  color: #06a6ce;
}

.Del-data-btn {
  padding: 40px 0;
}
.Del-data-btn .btn {
  margin-left: 15px;
  background-color: #fff;
  border-color: #f5f5f5;
  color: #ff485c;
}
.Del-data-btn .cancelbtn {
  color: #676a6c;
  text-align: center;
  font-size: 15px;
  font-family: "Open Sans", sans-serif;
  line-height: 1.5;
  padding: 6px;
}

.editmode {
  margin-bottom: 30px;
}
.editmode--btinp {
  margin-bottom: 0px;
}
.editmode--sc h3 {
  color: #676A6C !important;
}
.editmode__listrow {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 15px;
}
.editmode__listrow--nogap {
  grid-gap: 0;
}
@media only screen and (max-width: 767px) {
  .editmode__listrow {
    grid-template-columns: 1fr;
  }
}
.editmode__listrow--equalblocks {
  display: flex;
  flex-wrap: wrap;
}
.editmode__listrow--equalblocks > .editmode__listcol {
  flex: 1;
}
@media only screen and (max-width: 767px) {
  .editmode__listrow--equalblocks > .editmode__listcol {
    flex: none;
    width: 100%;
  }
}
.editmode__listrow--fullblocks {
  grid-template-columns: 1fr;
}
.editmode__listrow--grid1 {
  grid-template-columns: 1fr;
}
.editmode__listrow--grid3 > div:nth-child(1) {
  grid-row: 1/3;
}
.editmode__listrow--grid4 > div:nth-child(1) {
  grid-row: 1/4;
}
.editmode__listrow--grid5 > div:nth-child(1) {
  grid-row: 1/5;
}
.editmode__listrow--grid6 > div:nth-child(1) {
  grid-row: 1/6;
}
.editmode__listrow--grid7 > div:nth-child(1) {
  grid-row: 1/7;
}
.editmode__listcell {
  padding: 10px 15px;
  background-color: #EBEBEB;
  border: 1px solid #CFDBE2;
  border-radius: 6px;
  height: 100%;
}
.editmode__listcell--startbtn {
  border: 1px solid rgb(255, 121, 0);
  font-weight: 600;
  font-family: "Open Sans";
  font-size: 16px;
  cursor: pointer;
  line-height: 1;
  color: inherit !important;
}
@media only screen and (max-width: 767px) {
  .editmode__listcell {
    font-size: 13px;
  }
}
.editmode__listcell h3 {
  color: rgb(255, 121, 0);
  margin-bottom: 5px;
}
.editmode__listcell h3 a,
.editmode__listcell h3 i {
  color: inherit;
}
.editmode__listcell--ls li {
  list-style-type: disc;
  color: #676a6c;
}
.editmode__listcell--sc p {
  font-weight: normal !important;
}
.editmode__listcell--sc h3 button {
  font-family: "Open Sans";
  font-size: 16px;
  color: #676a6c;
  font-weight: 600;
  cursor: pointer;
}
.editmode__listcell p {
  font-size: 15px;
  font-weight: 600;
}
@media only screen and (max-width: 767px) {
  .editmode__listcell p {
    font-size: 13px;
  }
}
.editmode__listcell p:last-child {
  margin-bottom: 0;
}

.trackInfo {
  padding: 2px 16px;
  background-color: #6d6e71;
  color: #fff;
  margin-left: 40px;
  border-radius: 5px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  font-size: 10px;
}
.trackInfo--inputclr {
  color: rgb(255, 121, 0);
  font-size: 11px;
  background: transparent;
  margin-left: 8px;
  padding-left: 0;
  margin-bottom: 2px;
  display: inline-block;
}

.loader-container {
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
  top: 0;
  bottom: 0;
  background: rgba(236, 236, 236, 0.9);
  display: -ms-flexbox;
  display: none;
  justify-content: center;
  align-items: center;
  z-index: 9999999999;
  height: 100vh;
  margin: 0 auto;
}

.row--editmodebg {
  background-color: #fff;
  padding: 0 35px;
}
.row--wbg {
  background-color: #fff;
}

.loader-spin {
  background-color: hsla(0, 0%, 92.5%, 0.9);
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}

.loader__inner {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

#Path_129 {
  animation: blink 2s linear infinite;
  opacity: 0;
}

#Path_130 {
  animation: blink 2s linear infinite;
  animation-delay: 0.5s;
  opacity: 0;
}

#Path_132 {
  animation: blink 2s linear infinite;
  animation-delay: 1s;
  opacity: 0;
}

#Path_131 {
  animation: blink 2s linear infinite;
  animation-delay: 1.5s;
  opacity: 0;
}

@keyframes blink {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/challenges/ideate-challenge/ideate-challenge.component.scss","webpack://./src/app/components/challenges/_cn-shared.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;ACvUA;EACI,oCAAA;AD0UJ;;AAjZA;EACI,gBAAA;AAoZJ;;AA3YA;EACI,oBAAA;AA8YJ;;AA3YA;EACI,mBAAA;AA8YJ;;AAzYI;ECFA,aAAA;EAEA,eAAA;EDEI,mBAAA;AAgZR;AA9YQ;EAJJ;IAKQ,mBAAA;EAiZV;AACF;AA/YQ;EACI,mBAAA;AAiZZ;AA7YoB;EACI,kBAAA;EACA,oCAAA;EACA,gBAAA;EACA,eAAA;AA+YxB;AA7YwB;EANJ;IAOQ,kBAAA;IACA,eAAA;EAgZ1B;AACF;AA9YwB;EAXJ;IAYQ,YAAA;IACA,eAAA;EAiZ1B;AACF;AA7YwB;EACI,iCAAA;EACA,qCAAA;EACA,wCAAA;AA+Y5B;AAxYQ;EACI,gBAAA;AA0YZ;AAxYY;EACI,OAAA;EACA,kBAAA;AA0YhB;AAxYgB;EAJJ;IAKQ,UAAA;IACA,WAAA;EA2YlB;AACF;AAzYgB;EACI,WAAA;EACA,OAAA;AA2YpB;AAzYoB;EACI,WAAA;EACA,gBAAA;EACA,kBAAA;AA2YxB;AArYQ;EACI,gBAAA;AAuYZ;AArYY;EAHJ;IAIQ,qBAAA;EAwYd;AACF;AAtYY;EACI,aAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;AAwYhB;AAtYgB;EACI,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;AAwYpB;AArYoB;EACI,yBAAA;AAuYxB;AApYoB;EACI,iBAAA;AAsYxB;AApYwB;EAHJ;IAIQ,eAAA;EAuY1B;AACF;AApYoB;EA1BJ;IA2BQ,WAAA;IACA,YAAA;IACA,aAAA;EAuYtB;AACF;AArYoB;EACI,aAAA;AAuYxB;AApY4B;EACI,aAAA;AAsYhC;AAnY4B;EACI,aAAA;AAqYhC;AA/XgC;EACI,aAAA;AAiYpC;AA9XgC;EACI,aAAA;AAgYpC;AArX4B;EACI,aAAA;AAuXhC;AApX4B;EACI,aAAA;AAsXhC;AA5WI;EACI,kBAAA;AA8WR;AA5WQ;EACI,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;AA8WZ;AA5WY;EACI,gBAAA;EACA,MAAA;EACA,WAAA;EACA,sBAAA;AA8WhB;AA1WQ;EACI,gBAAA;AA4WZ;AAvWI;EACI,WAAA;EACA,8BDvLO;ECwLP,mBAAA;EACA,kBAAA;EACA,kBAAA;AAyWR;AAvWQ;EAPJ;IAQQ,kBAAA;EA0WV;AACF;AAxWQ;EACI,kCDjMG;AC2iBf;AAvWQ;EACI,eAAA;EACA,gBAAA;EACA,SAAA;EChKR,mCAAA;EACA,8BAAA;EDiKQ,aAAA;EACA,eAAA;EACA,mBAAA;AA0WZ;AAxWY;EATJ;IAUQ,eAAA;EA2Wd;AACF;AAzWY;EAbJ;IAcQ,eAAA;EA4Wd;AACF;AA1WY;EACI,kBAAA;AA4WhB;AAxWY;EACI,WAAA;EACA,cAAA;AA0WhB;AAxWgB;EAJJ;IAKQ,WAAA;IACA,eAAA;EA2WlB;AACF;AAvWQ;ECxOJ,aAAA;EAEA,eAAA;EAYA,mBAAA;ED6NQ,eAAA;AA+WZ;AAzWoB;EACI,qBAAA;AA2WxB;AAzWwB;EAHJ;IAIQ,OAAA;IACA,sBAAA;EA4W1B;AACF;AAvWY;EACI,eAAA;EACA,qBAAA;AAyWhB;AAvWgB;EACI,sBAAA;AAyWpB;AAtWgB;EACI,UAAA;AAwWpB;AAtWoB;EAHJ;IAIQ,OAAA;IACA,kBAAA;EAyWtB;AACF;AAtWgB;EACI,UAAA;AAwWpB;AAtWoB;EAHJ;IAIQ,YAAA;EAyWtB;AACF;AAtWgB;EACI,UAAA;EACA,iBAAA;EACA,iBAAA;AAwWpB;AAtWoB;EALJ;IAMQ,WAAA;EAyWtB;AACF;AAvWoB;EACI,eAAA;EACA,eAAA;AAyWxB;AAtWoB;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;AAwWxB;AAtWwB;EANJ;IAOQ,WAAA;IACA,UAAA;EAyW1B;AACF;AArWgB;EChTZ,aAAA;EAEA,eAAA;EAYA,mBAAA;ADipBJ;AA3WoB;EACI,kBAAA;AA6WxB;AAzWgB;EACI,UAAA;AA2WpB;AAxWgB;EC7TZ,aAAA;EAEA,eAAA;EAMA,uBAAA;ADuqBJ;AA9WoB;ECjUhB,aAAA;EAEA,eAAA;EDiUoB,SAAA;EACA,UAAA;EACA,kBAAA;EACA,cAAA;AAoXxB;AA/WoC;EACI,uBAAA;AAiXxC;AA7WwC;EADJ;IAEQ,WAAA;EAgX1C;AACF;AAzWoC;EACI,sBAAA;AA2WxC;AAvWwC;EADJ;IAEQ,YAAA;EA0W1C;AACF;AArW4B;EACI,iBAAA;AAuWhC;AAnWgC;EACI,kBAAA;AAqWpC;AAhWgC;EACI,uBD9WrB;EC+WqB,kCAAA;EACA,eAAA;AAkWpC;AAhWoC;EACI,uBDnXzB;ECoXyB,yBAAA;AAkWxC;AAhWwC;EACI,yBAAA;EACA,WAAA;AAkW5C;AA3VgC;EACI,YAAA;EACA,kCAAA;EACA,uBDlYrB;AC+tBf;AA3VoC;EACI,uBDrYzB;ECsYyB,yBAAA;AA6VxC;AA3VwC;EACI,yBAAA;EACA,WAAA;AA6V5C;AAvV4B;EACI,kBAAA;EACA,wBDjZhB;ECkZgB,eAAA;EACA,iBAAA;EC7W5B,mCAAA;EACA,8BAAA;ED8W4B,qBAAA;EACA,YAAA;EACA,SAAA;EACA,6BAAA;ECxY5B,yBAAA;ED4Y4B,gBAAA;AA4VhC;AA1VgC;EACI,kBAAA;EACA,SAAA;EACA,wBAAA;AA4VpC;AA1VoC;EACI,sBDrazB;ACiwBf;AAxVgC;EAzBJ;IA0BQ,gBAAA;IACA,eAAA;EA2VlC;AACF;AAzVgC;EACI,aAAA;EACA,gBAAA;AA2VpC;AAvVoC;EADJ;IAEQ,aAAA;EA0VtC;AACF;AAvVgC;EACI,aAAA;AAyVpC;AAvVoC;EAHJ;IAIQ,qBAAA;EA0VtC;AACF;AAvVgC;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kCDxcrB;ECycqB,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;AAyVpC;AAvVoC;EAfJ;IAgBQ,kBAAA;IACA,SAAA;IACA,YAAA;IACA,QAAA;IACA,SAAA;EA0VtC;AACF;AAvVgC;EACI,uBD1drB;EC2dqB,UAAA;AAyVpC;AAtVgC;EACI,uBD/drB;ECgeqB,yBAAA;EACA,UAAA;AAwVpC;AAjVgB;EACI,kBAAA;AAmVpB;AA/U4B;EACI,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,uCAAA;EACA,kBAAA;AAiVhC;AA3UgC;EACI,uBAAA;AA6UpC;AArUgC;EACI,cAAA;AAuUpC;AAvTY;EACI,kCAAA;EACA,6BAAA;EACA,iBAAA;EACA,kBAAA;EClfZ,mCAAA;EACA,8BAAA;EDmfY,uBD3hBD;EC4hBC,eAAA;EACA,gBAAA;EC5gBZ,yBAAA;ED8gBY,eAAA;AA4ThB;AA1TgB;EACI,kCDliBL;ECmiBK,WAAA;AA4TpB;AAzTgB;EACI,aAAA;AA2TpB;AAvTY;EACI,eAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;AAyThB;AAvTgB;EACI,uBDljBL;AC22Bf;AAtTgB;EACI,mBAAA;AAwTpB;AArTgB;EACI,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,uBD7jBL;EC8jBK,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,uCAAA;EACA,eAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AAuTpB;AAlTQ;EACI,eAAA;EACA,SAAA;EACA,eAAA;EACA,uBDjlBG;EEuCX,mCAAA;EACA,8BAAA;EA3CA,aAAA;EAEA,eAAA;EAYA,mBAAA;ADo4BJ;AAzTY;EATJ;IAUQ,eAAA;EA4Td;AACF;AA1TY;EAbJ;IAcQ,eAAA;IACA,sBAAA;EA6Td;AACF;AA3TY;EACI,iBAAA;AA6ThB;AAxTgB;EACI,uBDtmBL;ACg6Bf;AApTgB;EAFJ;IAGQ,WAAA;IACA,gBAAA;EAuTlB;AACF;AArTgB;EACI,0BAAA;EACA,8BAAA;EACA,6BAAA;AAuTpB;AArToB;EALJ;IAMQ,0BAAA;EAwTtB;AACF;AApTY;EACI,eAAA;EACA,gBAAA;AAsThB;AApTgB;EACI,iBAAA;AAsTpB;AApToB;EACI,cAAA;EACA,gBAAA;AAsTxB;AAlTgB;EACI,iBAAA;AAoTpB;AA9SQ;EACI,kBAAA;EACA,eAAA;EACA,qBAAA;AAgTZ;AA9SY;EACI,uBDtpBD;ACs8Bf;AA7SY;EACI,mBAAA;AA+ShB;AA5SY;EACI,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,uBDjqBD;ECkqBC,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,uCAAA;EACA,eAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AA8ShB;AAzSI;;EAEI,cAAA;EACA,gBAAA;AA2SR;AAxSI;EA6EI,kBAAA;EACA,qBAAA;EACA,SAAA;EACA,yCAAA;AA8NR;AA7SQ;EACI,gBAAA;AA+SZ;AA7SY;EACI,aAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AA+ShB;AA5SY;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AA8ShB;AA5SgB;EACI,mBAAA;EACA,kBAAA;AA8SpB;AA1SY;EACI,gBAAA;AA4ShB;AAxSQ;EACI,gBAAA;AA0SZ;AAvSQ;EACI,SAAA;EACA,kCAAA;EACA,kBAAA;AAySZ;AAvSY;EACI,6BAAA;EACA,4BAAA;AAyShB;AAvSgB;EACI,kCDluBL;AC2gCf;AAtSwB;EACI,WAAA;AAwS5B;AAlSgC;EACI,kBAAA;EACA,sBAAA;AAoSpC;AAlSoC;EACI,uBDjvBzB;ECkvByB,sBAAA;AAoSxC;AAjSoC;EACI,qBAAA;AAmSxC;AA5RoB;EACI,WAAA;AA8RxB;AAnRQ;EACI,kBAAA;EACA,YAAA;EACA,gBAAA;AAqRZ;AAnRY;EALJ;IAMQ,kBAAA;EAsRd;AACF;AAnRQ;EACI,aAAA;EACA,yBAAA;EACA,aAAA;EACA,0BAAA;EACA,gBAAA;AAqRZ;AAnRY;EACI,cAAA;AAqRhB;AAnRgB;EACI,sBAAA;AAqRpB;AAhRY;EACI,aAAA;AAkRhB;AA9QgB;EACI,eAAA;EACA,gBAAA;AAgRpB;AA9QoB;EAJJ;IAKQ,eAAA;EAiRtB;AACF;AA/QoB;EACI,gBAAA;AAiRxB;AA7QgB;EACI,eAAA;AA+QpB;AA7QoB;EACI,UAAA;EACA,eAAA;AA+QxB;AA7QwB;EAJJ;IAKQ,WAAA;EAgR1B;AACF;AA9QwB;EACI,kBAAA;EACA,kBAAA;AAgR5B;AA9Q4B;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;AAgRhC;AAzQY;EACI,kBAAA;EACA,mBAAA;EACA,kBAAA;AA2QhB;AAzQgB;EACI,gBAAA;AA2QpB;AAxQgB;EACI,kBAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;AA0QpB;AAxQoB;EACI,UAAA;AA0QxB;AArQgB;EACI,eAAA;AAuQpB;AApQgB;EACI,cAAA;EACA,eAAA;AAsQpB;AApQoB;EACI,iBAAA;AAsQxB;AA/PY;EACI,eAAA;AAiQhB;AA9PY;EACI,UAAA;EACA,SAAA;AAgQhB;AA9PgB;EACI,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;AAgQpB;AA9PoB;EACI,kBAAA;EACA,uBD94BT;EC+4BS,UAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EAGA,gCAAA;AAgQxB;AA3PoB;EACI,8BD35BT;ACwpCf;AA1PoB;EACI,UAAA;AA4PxB;AAtPQ;EACI,aAAA;AAwPZ;AAtPY;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAwPhB;AAtPgB;EACI,kBAAA;EACA,QAAA;EACA,iBAAA;AAwPpB;AArPgB;EACI,sBAAA;AAuPpB;AAnPY;EACI,UAAA;EACA,kBAAA;EACA,aAAA;AAqPhB;AAnPgB;EACI,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;AAqPpB;AAnPoB;EACI,eAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EAGA,gCAAA;AAqPxB;AAhPoB;EACI,8BD99BT;EC+9BS,kCD/9BT;ACitCf;AA/OoB;EACI,UAAA;AAiPxB;AA3OQ;EACI,yBAAA;EACA,6BAAA;EACA,kBAAA;AA6OZ;AA3OY;ECj/BR,aAAA;EAEA,eAAA;EAYA,mBAAA;ADwtCJ;AAjPgB;EACI,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;ECr+BhB,yBAAA;AD2tCJ;AAnPoB;EACI,iBAAA;AAqPxB;AAlPoB;EACI,iBAAA;EACA,gBAAA;AAoPxB;AAhPgB;EACI,iBAAA;AAkPpB;AA/OgB;EACI,kCDxgCL;ECygCK,8BDzgCL;EC0gCK,WAAA;AAiPpB;AA/OoB;EACI,kCD7gCT;EC8gCS,8BD9gCT;AC+vCf;AA7OgB;EACI,yBAAA;EACA,qBAAA;AA+OpB;AA7OoB;EACI,yBAAA;EACA,qBAAA;AA+OxB;AA3OgB;EACI,sBAAA;EACA,kBAAA;EACA,cAAA;AA6OpB;AA3OoB;EACI,yBAAA;EACA,qBAAA;AA6OxB;AAxOoB;EACI,SAAA;AA0OxB;AAtOgB;EACI,SAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;ECniChB,yBAAA;AD8wCJ;AAxOoB;EACI,kBAAA;EACA,UAAA;ECxiCpB,yBAAA;ADqxCJ;AAzOoB;EACI,sBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AA2OxB;AAzOwB;EACI,kBAAA;EACA,OAAA;AA2O5B;AAxOwB;EACI,iBAAA;AA0O5B;AAtOoB;EACI,cAAA;EACA,eAAA;EC9jCpB,yBAAA;ADyyCJ;AApOQ;EACI,gBAAA;EACA,kBAAA;EACA,6BAAA;AAsOZ;AAnOY;EANJ;IAOQ,kBAAA;EAsOd;AACF;AApOY;EACI,cAAA;ECpmCZ,aAAA;EAEA,eAAA;EAYA,mBAAA;ADo0CJ;AA1OgB;EACI,cAAA;AA4OpB;AA1OoB;EAHJ;IAIQ,WAAA;IACA,kBAAA;EA6OtB;EA3OsB;IACI,gBAAA;EA6O1B;AACF;AAzOwB;EACI,iBAAA;AA2O5B;AAtOgB;EACI,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AAwOpB;AAtOoB;EARJ;IASQ,eAAA;EAyOtB;AACF;AAvOoB;;EAEI,iBAAA;EACA,gBAAA;AAyOxB;AAtOoB;EACI,mCD1oCR;EC2oCQ,WAAA;AAwOxB;AArOoB;EACI,kCDjpCR;ECkpCQ,WAAA;AAuOxB;AApOoB;EACI,kCDrpCT;ECspCS,WAAA;EACA,8BDvpCT;ECwpCS,gBAAA;AAsOxB;AAnOoB;EACI,YAAA;AAqOxB;AAlOoB;EACI,yBAAA;EACA,WAAA;EACA,qBAAA;AAoOxB;AAjOoB;EACI,UAAA;EACA,6BAAA;EACA,cAAA;EACA,cD5pCH;EC6pCG,SAAA;EACA,wEDjsCX;ECksCW,eAAA;EACA,gBAAA;AAmOxB;AAjOwB;EACI,WAAA;AAmO5B;AA/NoB;EACI,yBAAA;EACA,WAAA;AAiOxB;AA9NoB;EACI,cAAA;AAgOxB;AA7NoB;EACI,SAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;ECnrCpB,yBAAA;ADq5CJ;AAhOwB;EACI,eAAA;EACA,cD3rCP;AC65CrB;AA7NwB;EACI,kBAAA;EACA,UAAA;EC9rCxB,yBAAA;ADg6CJ;AA9NwB;EACI,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AAgO5B;AA9N4B;EANJ;IAOQ,kBAAA;IACA,iBAAA;EAiO9B;AACF;AA/N4B;EACI,kBAAA;EACA,OAAA;AAiOhC;AA9N4B;EACI,iBAAA;AAgOhC;AA5NwB;EA3CJ;IA4CQ,yBAAA;IACA,cAAA;IACA,mBAAA;IACA,kBAAA;EA+N1B;AACF;AA9N4B;EAjDR;IAkDY,kBAAA;IACA,iBAAA;EAiO9B;AACF;AA1OwB;EAWI;IACI,kBAAA;IACA,OAAA;EAkO9B;EA/N0B;IACI,4BAAA;EAiO9B;AACF;AA9NwB;EACI,cAAA;EACA,eAAA;EC9uCxB,yBAAA;ADi9CJ;AA1NQ;EACI,uBAAA;EACA,kCAAA;EACA,mBAAA;AA4NZ;AA1NY;EACI,uBD9wCD;AC0+Cf;AAxNQ;EACI,uBDnxCG;AC6+Cf;AAvNQ;EACI,eAAA;AAyNZ;AAvNY;EACI,gBAAA;AAyNhB;AArNQ;EACI,kBAAA;AAuNZ;AArNY;;EAEI,WAAA;EACA,eAAA;EACA,kBAAA;AAuNhB;AArNgB;;;;EAEI,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;AAyNpB;AArNY;EACI,eAAA;ECrzCZ,aAAA;EAEA,eAAA;AD+gDJ;AAzNgB;EACI,eAAA;EACA,WAAA;EACA,mBAAA;AA2NpB;AAzNoB;EACI,kBAAA;AA2NxB;AAvNgB;EACI,gBAAA;EACA,oCAAA;EACA,eAAA;AAyNpB;AAvNoB;EACI,mBAAA;AAyNxB;AArNgB;EAGI,gBAAA;EACA,iFAAA;EACA,qBAAA;EACA,sCAAA;EACA,4BAAA;AAuNpB;AApNgB;EACI,WAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AAsNpB;AAnNgB;;EC/1CZ,aAAA;EAEA,eAAA;ADwjDJ;AAvNoB;;EACI,WAAA;EACA,mBAAA;ECr2CpB,aAAA;EAEA,eAAA;EAYA,mBAAA;ADyjDJ;AA7NoB;;EACI,WAAA;EACA,kBAAA;EC52CpB,aAAA;EAEA,eAAA;EAYA,mBAAA;EANA,uBAAA;EDw2CoB,eAAA;EACA,0BAAA;AAwOxB;AAtOwB;;EACI,wBAAA;EACA,mBAAA;AAyO5B;AAvO4B;;EACI,kBAAA;AA0OhC;AAxOgC;;EACI,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,SAAA;EACA,eAAA;EACA,uBD73CrB;ACwmDf;AAzOoC;;;EAEI,cAAA;AA4OxC;AAzOoC;;EACI,aAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,uCAAA;EACA,kBAAA;AA4OxC;AAxOgC;;EACI,kBAAA;AA2OpC;AAnOwB;;EACI,gBAAA;AAsO5B;AAlOoB;;EACI,YAAA;EACA,mBAAA;AAqOxB;AAlOoB;;EACI,yBAAA;AAqOxB;AAnOwB;;EACI,mBAAA;AAsO5B;AApO4B;;;EAEI,aAAA;AAuOhC;AAjO4B;;EACI,aAAA;AAoOhC;AA/NoB;;EACI,WAAA;AAkOxB;AA3NgB;EACI,cAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;EACA,cD77CC;EEIjB,yBAAA;ADypDJ;AA7NoB;EACI,kCD98CT;EC+8CS,kCAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AA+NxB;AAzNQ;EAQI,oBAAA;ECr9CR,mBAAA;EDu9CQ,WAAA;EACA,gBAAA;EACA,SAAA;AAwNZ;AAnOY;EACI,kBAAA;EACA,SAAA;AAqOhB;AAvNY;EACI,YAAA;EACA,kBAAA;AAyNhB;AAtNY;;EAEI,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AAwNhB;AArNY;EACI,WAAA;EACA,SAAA;AAuNhB;AApNY;EACI,SAAA;AAsNhB;AAnNY;EACI,UAAA;EACA,iBAAA;AAqNhB;AAjNQ;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,QAAA;EAGA,2BAAA;ECvgDR,yBAAA;AD6tDJ;AAnNY;EACI,kCD5hDD;EC6hDC,8BD7hDD;EC8hDC,WAAA;AAqNhB;AAjNQ;EAGI,aAAA;EAEA,eAAA;EACA,sBAAA;AAmNZ;AAhNgB;EACI,WAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBAAA;EACA,mBAAA;AAkNpB;AA9MoB;EAEI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;AA+MxB;AA5MoB;EACI,WAAA;EACA,UAAA;AA8MxB;AAxMgB;EACI,WAAA;AA0MpB;AAtMY;EACI,kBAAA;EACA,kBAAA;AAwMhB;AAtMgB;EACI,0BAAA;EACA,6BAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AAwMpB;AAlMI;EACI,aAAA;EACA,iBAAA;EAGA,aAAA;EAEA,eAAA;AAoMR;AAlMQ;EACI,UAAA;EACA,mBAAA;AAoMZ;AAhMI;EAGI,aAAA;EAEA,eAAA;EAGA,mBAAA;EACA,mBAAA;AAkMR;AAhMQ;EACI,wBAAA;EACA,qBAAA;EACA,kBAAA;AAkMZ;AAhMY;EACI,WAAA;EACA,kBAAA;EAGA,aAAA;EAEA,eAAA;AAkMhB;AAhMgB;EACI,kBAAA;EACA,WAAA;AAkMpB;AAhMoB;EACI,uBAAA;EACA,8BDzoDT;EC0oDS,YAAA;EACA,UAAA;EAGA,aAAA;EAGA,mBAAA;EAGA,uBAAA;AAkMxB;AA9LgB;EACI,wBAAA;EACA,YAAA;EACA,kCAAA;EACA,kCAAA;AAgMpB;AAzLQ;EACI,eAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EAGA,yBAAA;AA2LZ;AAzLY;EACI,YAAA;AA2LhB;AAxLY;EACI,gBAAA;AA0LhB;AAvLY;EACI,kCDtrDA;AC+2DhB;AAtLY;EACI,kCDzrDD;ACi3Df;AArLY;EACI,kCD3rDE;ACk3DlB;AAlLI;EACI,kBAAA;AAoLR;AAlLQ;EACI,kBAAA;EACA,MAAA;EACA,QAAA;AAoLZ;AAlLY;EACI,QAAA;AAoLhB;AAlLgB;EACI,eAAA;EACA,WAAA;EAGA,8BAAA;AAoLpB;AAhLY;EACI,WAAA;EACA,SAAA;AAkLhB;AAhLgB;EACI,eAAA;EAIA,sBAAA;EAGA,8BAAA;EACA,YAAA;EACA,WAAA;EAGA,mBAAA;AAkLpB;AA9KY;EACI,mBAAA;EAGA,aAAA;EAEA,eAAA;AAgLhB;AA9KgB;EACI,yBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;AAgLpB;AA5KY;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,wCAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,sBAAA;AA8KhB;AA5KgB;EACI,eAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;EAGA,yBAAA;AA8KpB;AA5KoB;EAGI,yBAAA;AA8KxB;AA1KgB;EACI,aAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,wCAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;AA4KpB;AA1KoB;EACI,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AA4KxB;AA1KwB;EACI,SAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AA4K5B;AAvKgB;EACI,kBAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AAyKpB;AAtKgB;EACI,SAAA;AAwKpB;AAtKoB;EACI,iBAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;AAwKxB;AAtKwB;EACI,uCAAA;AAwK5B;AA/JQ;EACI,mBAAA;EACA,gBAAA;EACA,gBAAA;EAGA,aAAA;EAEA,iBAAA;AAiKZ;AA/JY;EACI,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;AAiKhB;AA/JgB;EACI,mBAAA;AAiKpB;AA9JgB;EACI,iBAAA;AAgKpB;AA7JgB;EAjBJ;IAkBQ,UAAA;EAgKlB;AACF;AA9JgB;EArBJ;IAsBQ,WAAA;EAiKlB;AACF;AA/JgB;EAGI,aAAA;EAEA,eAAA;AAiKpB;AA/JoB;EACI,wBAAA;EACA,sBAAA;EACA,0BAAA;AAiKxB;AA9JoB;EACI,WAAA;AAgKxB;AA9JwB;EACI,kCDr4Db;ECs4Da,gBAAA;EACA,WAAA;EACA,8BDx4Db;ECy4Da,wED/5Df;AC+jEb;AA7JwB;EACI,YAAA;AA+J5B;AAzJY;EACI,aAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AA2JhB;AAzJgB;EACI,qBAAA;EACA,kBAAA;EACA,sBAAA;AA2JpB;AAxJgB;EACI,UAAA;EACA,kBAAA;AA0JpB;AAxJoB;EACI,kBAAA;EACA,SAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;AA0JxB;AAxJwB;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EAGA,gCAAA;AA0J5B;AAtJoB;EACI,kCD77DT;EC87DS,8BD97DT;ACslEf;AArJoB;EACI,UAAA;AAuJxB;AAlJY;EAGI,aAAA;EAEA,eAAA;EAGA,mBAAA;AAoJhB;AAlJgB;EACI,kBAAA;EACA,UAAA;AAoJpB;AAlJoB;EACI,8BDt9DT;ECu9DS,yBDv9DT;AC2mEf;AAhJgB;EACI,iBAAA;AAkJpB;AA/IgB;EACI,iBAAA;AAiJpB;AA7IoB;EACI,eAAA;EACA,cAAA;EACA,eAAA;AA+IxB;AA3IgB;EACI,gBAAA;EACA,eAAA;EACA,WAAA;EACA,mCD9+DJ;AC2nEhB;AAzIY;EACI,UAAA;EACA,SAAA;EACA,gBAAA;AA2IhB;AAzIgB;EACI,gBAAA;EACA,UAAA;EACA,WAAA;AA2IpB;AAzIoB;EACI,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;AA2IxB;;AAnIA;EACI,gBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,MAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,aAAA;EACA,wCAAA;ECrgEA,yBAAA;EDugEA,gBAAA;AAwIJ;AAtII;EACI,QAAA;AAwIR;AArII;EACI,gBAAA;AAuIR;AApII;ECriEA,aAAA;EAEA,eAAA;EDqiEI,UAAA;EACA,gBAAA;AA0IR;AAxIQ;EACI,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;AA0IZ;AAxIY;EACI,WAAA;EACA,uBD/iED;ECgjEC,eAAA;EACA,iBAAA;EC1gEZ,mCAAA;EACA,8BAAA;ED2gEY,qBAAA;EACA,YAAA;EACA,SAAA;EACA,kCAAA;EACA,6BAAA;EACA,yBAAA;EC3hEZ,gBAAA;ADyqEJ;AA3IgB;EACI,aAAA;AA6IpB;AA1IgB;EACI,YAAA;AA4IpB;AA1IoB;EACI,UAAA;AA4IxB;AAxIgB;EACI,UAAA;AA0IpB;AAvIgB;EACI,kBAAA;EACA,UAAA;AAyIpB;AArIY;EACI,iBAAA;AAuIhB;AAnIgB;EACI,0BAAA;AAqIpB;AAhIgB;EACI,0BAAA;AAkIpB;AA5HI;EACI,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AA8HR;AA3HI;EACI,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AA6HR;AA1HI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;ECtmEJ,yBAAA;ADquEJ;AA5HQ;EAGI,yBAAA;AA8HZ;AA3HQ;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EAGA,wBAAA;AA6HZ;AA3HY;EACI,kBAAA;EACA,mBAAA;AA6HhB;AA3HgB;EACI,MAAA;EACA,qBAAA;EACA,UAAA;EACA,YAAA;AA6HpB;AA1HgB;EACI,oBAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;AA4HpB;AAtHI;EACI,gBAAA;AAwHR;AArHY;EACI,gBAAA;EACA,mBAAA;AAuHhB;AArHgB;EACI,gBAAA;EACA,yBAAA;AAuHpB;AArHoB;;EAEI,yBAAA;EACA,gBAAA;AAuHxB;AAnHgB;EACI,gBAAA;AAqHpB;AAhHgB;EACI,uBD1rEJ;AC4yEhB;AA7GgB;EACI,uBD/rEL;AC8yEf;AA1GgB;EACI,wBDpsEJ;ACgzEhB;AAvGgB;EACI,uBDzsEF;ACkzElB;AArGY;EACI,eAAA;EACA,gBAAA;EACA,eAAA;EC3qEZ,mCAAA;EACA,8BAAA;ADmxEJ;AAtGgB;EACI,eAAA;AAwGpB;AApGY;EACI,kBAAA;EACA,gBAAA;AAsGhB;AApGgB;EACI,gBAAA;AAsGpB;AAlGY;EACI,gBAAA;AAoGhB;AA/FI;EACI,UAAA;EACA,SAAA;AAiGR;AA/FQ;EACI,gBAAA;EACA,WAAA;AAiGZ;AA/FY;EACI,kBAAA;EACA,uBDnvED;EEiBX,yBAAA;ADs0EJ;AA/FgB;EACI,aAAA;AAiGpB;AA7FY;EACI,eAAA;AA+FhB;;AApFQ;EACI,kBAAA;EACA,eAAA;EACA,kCAAA;EACA,YAAA;EACA,kBAAA;ECjxER,aAAA;EAEA,eAAA;AD22EJ;AAzFY;EACI,kBAAA;EACA,MAAA;EACA,OAAA;AA2FhB;AAxFY;EACI,SAAA;EACA,kBAAA;EACA,uBD1xED;EC2xEC,kBAAA;ECpvEZ,mCAAA;EACA,8BAAA;AD+0EJ;AAzFgB;EC7wEZ,yBAAA;AD22EJ;AAxFQ;EACI,kCAAA;EACA,aAAA;EACA,aAAA;EACA,0BAAA;AA0FZ;AAxFY;EACI,aAAA;AA0FhB;AAxFgB;EACI,gBAAA;AA0FpB;AAvFgB;EACI,gBAAA;EACA,kBAAA;EACA,uBDpzEL;EEuCX,mCAAA;EACA,8BAAA;ADu2EJ;AAvFgB;EACI,SAAA;EACA,UAAA;AAyFpB;AAvFoB;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAyFxB;AAvFwB;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;AAyF5B;AAtFwB;EACI,eAAA;AAwF5B;AAjFQ;EACI,gBAAA;EACA,oBAAA;AAmFZ;AAjFY;EACI,kBAAA;AAmFhB;AAhFgB;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,sBAAA;EACA,uBAAA;AAkFpB;AA7EQ;EACI,gBAAA;AA+EZ;AA5EQ;EACI,mBAAA;EACA,8BAAA;AA8EZ;AA1EY;EACI,0BAAA;AA4EhB;AA1EgB;EAn4EZ,wBAAA;AAk9EJ;AAxEY;EACI,cAAA;AA0EhB;AAnEQ;EACI,kCAAA;AAqEZ;AAlEQ;EACI,WAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;AAoEZ;AAjEQ;EACI,cAAA;AAmEZ;AAhEQ;EACI,kCDr5EG;ECs5EH,8BDt5EG;ACw9Ef;AA/DQ;EACI,iBAAA;EACA,kBAAA;EACA,aAAA;AAiEZ;AA/DY;EACI,gBAAA;AAiEhB;AA3DY;EACI,6BAAA;EACA,SAAA;AA6DhB;AA3DgB;EACI,gBAAA;AA6DpB;;AApDA;EACI,eAAA;AAuDJ;AArDI;ECz7EA,aAAA;EAEA,eAAA;EAYA,mBAAA;ED86EI,UAAA;EACA,SAAA;AA6DR;AA1DI;EACI,gBAAA;AA4DR;AA1DQ;EACI,iBAAA;AA4DZ;AAxDY;EACI,UAAA;AA0DhB;AAtDQ;EACI,kCD38EG;EC48EH,WAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;AAwDZ;AAtDY;EACI,SAAA;AAwDhB;AApDQ;EC/6EJ,mCAAA;EACA,8BAAA;EDg7EQ,eAAA;EACA,cAAA;EACA,aAAA;EACA,cAAA;EACA,qBAAA;EC38ER,yBAAA;ADqgFJ;AAvDY;EACI,kBAAA;EACA,gBAAA;EACA,OAAA;ECj9EZ,yBAAA;AD6gFJ;;AArDA;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;AAwDJ;;AArDA;EACI,eAAA;AAwDJ;AAtDI;EACI,iBAAA;EACA,sBAAA;EACA,qBAAA;EACA,cAAA;AAwDR;AArDI;EACI,cAAA;EACA,kBAAA;EACA,eAAA;EACA,oCAAA;EACA,gBAAA;EACA,YAAA;AAuDR;;AAlDA;EACI,mBAAA;AAqDJ;AAnDI;EACI,kBAAA;AAqDR;AAhDQ;EACI,yBAAA;AAkDZ;AA5CQ;EACI,aAAA;EACA,qCAAA;EACA,cAAA;AA8CZ;AA5CY;EACI,WAAA;AA8ChB;AA3CY;EATJ;IAUQ,0BAAA;EA8Cd;AACF;AA5CY;EACI,aAAA;EACA,eAAA;AA8ChB;AA5CgB;EACI,OAAA;AA8CpB;AA5CoB;EAHJ;IAIQ,UAAA;IACA,WAAA;EA+CtB;AACF;AA1CY;EACI,0BAAA;AA4ChB;AAxCgB;EACI,0BAAA;AA0CpB;AArCoB;EACI,aAAA;AAuCxB;AAjCoB;EACI,aAAA;AAmCxB;AA7BoB;EACI,aAAA;AA+BxB;AAzBoB;EACI,aAAA;AA2BxB;AArBoB;EACI,aAAA;AAuBxB;AAjBQ;EACI,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;AAmBZ;AAjBY;EACI,kCAAA;EAEA,gBAAA;EACA,wBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;AAkBhB;AAfY;EAlBJ;IAmBQ,eAAA;EAkBd;AACF;AAhBY;EACI,uBDtnFD;ECunFC,kBAAA;AAkBhB;AAhBgB;;EAEI,cAAA;AAkBpB;AAbgB;EACI,qBAAA;EACA,cAAA;AAepB;AAVgB;EACI,8BAAA;AAYpB;AARoB;EACI,wBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAUxB;AALY;EACI,eAAA;EACA,gBAAA;AAOhB;AALgB;EAJJ;IAKQ,eAAA;EAQlB;AACF;AANgB;EACI,gBAAA;AAQpB;;AAAA;EACI,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,4BAAA;EACA,6BAAA;EACA,eAAA;AAGJ;AADI;EACI,uBDlrFO;ECmrFP,eAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;AAGR;;AACA;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,oCAAA;EAEA,oBAAA;EACA,aAAA;EAGA,uBAAA;EAGA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;AAEJ;;AAEI;EACI,sBAAA;EACA,eAAA;AACR;AAEI;EACI,sBAAA;AAAR;;AAIA;EACI,yCAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;AADJ;;AAIA;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;AADJ;;AAKA;EACI,mCAAA;EACA,UAAA;AAFJ;;AAKA;EACI,mCAAA;EACA,qBAAA;EACA,UAAA;AAFJ;;AAKA;EACI,mCAAA;EACA,mBAAA;EACA,UAAA;AAFJ;;AAKA;EACI,mCAAA;EACA,qBAAA;EACA,UAAA;AAFJ;;AAKA;EACI;IACI,UAAA;EAFN;EAKE;IACI,UAAA;EAHN;EAME;IACI,UAAA;EAJN;AACF","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import './../cn-shared';\n\nli {\n    list-style: none;\n}\n\n@mixin transRotate ($rotate) {\n    -webkit-transform: rotate($rotate);\n    -ms-transform: rotate($rotate);\n    transform: rotate($rotate);\n}\n\n::ng-deep#page-wrapper {\n    padding-bottom: 60px;\n}\n\n::ng-deep#wrapper {\n    overflow-x: initial;\n}\n\n::ng-deep.ideate-is {\n\n    .mainnav {\n        @include fflex();\n        margin: 30px 0 20px;\n\n        @media #{$mq-sm} {\n            margin: 10px 0 15px;\n        }\n\n        &.mainnav--bottom {\n            margin: 30px 0 40px;\n\n            ul {\n                li {\n                    a {\n                        padding: 12px 30px;\n                        font-family: 'Open Sans', sans-serif;\n                        font-weight: 700;\n                        font-size: 16px;\n\n                        @media only screen and (max-width: 991px) {\n                            padding: 10px 20px;\n                            font-size: 14px;\n                        }\n\n                        @media only screen and (max-width: 767px) {\n                            padding: 9px;\n                            font-size: 11px;\n                        }\n                    }\n\n                    &.active {\n                        a {\n                            background-color: #bbb !important;\n                            border-top: 1px solid #bbb !important;\n                            border-bottom: 1px solid #bbb !important;\n                        }\n                    }\n                }\n            }\n        }\n\n        &--editmode {\n            margin: 0 0 15px;\n\n            .mainnav__list {\n                flex: 1;\n                border-radius: 5px;\n\n                @media #{$mq-sm} {\n                    flex: none;\n                    width: 100%;\n                }\n\n                li {\n                    width: 100%;\n                    flex: 1;\n\n                    a {\n                        width: 100%;\n                        padding: 5px 2px;\n                        text-align: center;\n                    }\n                }\n            }\n        }\n\n        &__editmodeicon {\n            margin-left: 5px;\n\n            @media #{$mq-sm} {\n                margin: 10px 0 0 auto;\n            }\n\n            ul {\n                display: flex;\n                flex-wrap: wrap;\n                margin: 0;\n                padding: 0;\n                height: 100%;\n\n                li {\n                    list-style: none;\n                    transition: none;\n                    width: 37px;\n                    height: 100%;\n                    border-radius: 5px;\n                    background-color: #fff;\n                    display: flex;\n                    justify-content: center;\n                    align-items: center;\n                    cursor: pointer;\n                    border: 1px solid $cn-border-color;\n\n\n                    &.active {\n                        background-color: #676a6c;\n                    }\n\n                    &:not(:last-child) {\n                        margin-right: 5px;\n\n                        @media #{$mq-md} {\n                            margin-right: 0;\n                        }\n                    }\n\n                    @media #{$mq-md} {\n                        width: 35px;\n                        height: 31px;\n                        display: none;\n                    }\n\n                    &.mainnav__editmodepin {\n                        display: flex;\n\n                        svg {\n                            .st0 {\n                                fill: #FFFFFF;\n                            }\n\n                            .st1 {\n                                fill: #cfdbe2;\n                            }\n                        }\n\n                        &--pinactive {\n                            svg {\n                                .st0 {\n                                    fill: #6d6e71;\n                                }\n\n                                .st1 {\n                                    fill: #FFFFFF;\n                                }\n                            }\n                        }\n                    }\n\n                    &.listView,\n                    &.individualView,\n                    &.gridView {\n\n                        svg {\n                            .st0 {\n                                fill: #6d6e71;\n                            }\n\n                            .st1 {\n                                fill: #FFFFFF;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n\n    }\n\n    .stick-challenge {\n        position: relative;\n\n        .card-body__edit {\n            min-height: auto;\n            overflow-y: auto;\n            overflow-x: hidden;\n            z-index: 9;\n            position: relative;\n\n            .card-body__subtitle {\n                position: sticky;\n                top: 0;\n                z-index: 99;\n                background-color: #fff;\n            }\n        }\n\n        .card-body__inner {\n            overflow-y: auto;\n        }\n\n    }\n\n    .info {\n        color: #fff;\n        border-color: $ideate-color;\n        margin-bottom: 18px;\n        padding: 20px 40px;\n        border-radius: 6px;\n\n        @media #{$mq-md} {\n            padding: 12px 20px;\n        }\n\n        &.infotitle {\n            background-color: $ideate-color;\n        }\n\n        h1 {\n            font-size: 36px;\n            font-weight: 500;\n            margin: 0;\n            @include headingfont();\n            display: flex;\n            flex-wrap: wrap;\n            align-items: center;\n\n            @media #{$mq-md} {\n                font-size: 28px;\n            }\n\n            @media #{$mq-sm} {\n                font-size: 24px;\n            }\n\n            .info__maintitle {\n                margin-right: auto;\n\n            }\n\n            small {\n                color: #fff;\n                font-size: 80%;\n\n                @media #{$mq-sm} {\n                    width: 100%;\n                    margin-top: 5px;\n                }\n            }\n        }\n\n        .card__toprow {\n            @include fflex();\n            @include fflex-aic();\n            margin: 0 -15px;\n\n            &--tne {\n\n                .card__topcol {\n\n                    &:first-child {\n                        width: 72% !important;\n\n                        @media #{$mq-sm} {\n                            flex: 1;\n                            width: auto !important;\n                        }\n                    }\n                }\n            }\n\n            .card__topcol {\n                padding: 0 15px;\n                width: calc(100% / 3);\n\n                &--full {\n                    width: 100% !important;\n                }\n\n                &:nth-child(1) {\n                    width: 28%;\n\n                    @media #{$mq-sm} {\n                        flex: 1;\n                        margin-right: auto;\n                    }\n                }\n\n                &--tab {\n                    width: 44%;\n\n                    @media #{$mq-sm} {\n                        width: 120px;\n                    }\n                }\n\n                &--tt {\n                    width: 28%;\n                    margin-left: auto;\n                    text-align: right;\n\n                    @media #{$mq-sm} {\n                        width: auto;\n                    }\n\n                    svg {\n                        max-width: 16px;\n                        cursor: pointer;\n                    }\n\n                    .card__pinicon {\n                        position: absolute;\n                        right: -17px;\n                        top: -15px;\n                        width: 20px;\n\n                        @media #{$mq-md} {\n                            right: -1px;\n                            top: -10px;\n                        }\n                    }\n                }\n\n                &.card__topcol--title {\n                    @include fflex();\n                    @include fflex-aic();\n\n                    &>div:first-child {\n                        margin-right: 15px;\n                    }\n                }\n\n                &.card__topcol--startexist {\n                    width: 65%;\n                }\n\n                &.card__topcol--tab {\n                    @include fflex();\n                    @include fflex-jcc();\n\n                    ul {\n                        @include fflex();\n                        margin: 0;\n                        padding: 0;\n                        border-radius: 3px;\n                        line-height: 1;\n\n                        li {\n                            &:first-child {\n                                button {\n                                    svg {\n                                        right: calc(100% + 1px)\n                                    }\n\n                                    span.card__topcount {\n                                        @media only screen and (max-width: 630px) {\n                                            left: -30px;\n                                        }\n                                    }\n                                }\n                            }\n\n                            &:last-child {\n                                button {\n                                    svg {\n                                        left: calc(100% + 1px);\n                                    }\n\n                                    span.card__topcount {\n                                        @media only screen and (max-width: 630px) {\n                                            right: -30px;\n                                        }\n                                    }\n                                }\n                            }\n\n                            &:not(:first-child) {\n                                margin-left: -1px;\n                            }\n\n                            &:only-child {\n                                button {\n                                    border-radius: 3px;\n                                }\n                            }\n\n                            &.card__topactive {\n                                button {\n                                    color: $ideate-color;\n                                    border: 1px solid $ideate-color;\n                                    cursor: pointer;\n\n                                    span.card__topcount {\n                                        color: $ideate-color;\n                                        background-color: #efefef;\n\n                                        &.redConverge_count {\n                                            background-color: #EC2121;\n                                            color: #fff;\n                                        }\n                                    }\n                                }\n                            }\n\n                            &.card__topcomplete {\n                                button {\n                                    opacity: 0.2;\n                                    border: 1px solid $ideate-color;\n                                    color: $ideate-color;\n\n                                    span.card__topcount {\n                                        color: $ideate-color;\n                                        background-color: #efefef;\n\n                                        &.redConverge_count {\n                                            background-color: #EC2121;\n                                            color: #fff;\n                                        }\n                                    }\n                                }\n                            }\n\n                            button {\n                                position: relative;\n                                color: $develop-color;\n                                font-size: 17px;\n                                padding: 6px 16px;\n                                @include headingfont();\n                                display: inline-block;\n                                height: 100%;\n                                border: 0;\n                                background-color: transparent;\n                                @include transition-slow();\n                                -webkit-appearance: none;\n                                -moz-appearance: none;\n                                appearance: none;\n\n                                svg {\n                                    position: absolute;\n                                    top: -1px;\n                                    height: calc(100% + 2px);\n\n                                    .st0 {\n                                        fill: $ideate-color;\n                                    }\n                                }\n\n                                @media #{$mq-md} {\n                                    padding: 4px 6px;\n                                    font-size: 13px;\n                                }\n\n                                &:focus {\n                                    outline: none;\n                                    box-shadow: none;\n                                }\n\n                                &>.card__topdesktext {\n                                    @media only screen and (max-width: 1180px) {\n                                        display: none;\n                                    }\n                                }\n\n                                &>.card__topmobiletext {\n                                    display: none;\n\n                                    @media only screen and (max-width: 1180px) {\n                                        display: inline-block;\n                                    }\n                                }\n\n                                &>span.card__topcount {\n                                    width: 16px;\n                                    height: 16px;\n                                    line-height: 16px;\n                                    display: inline-block;\n                                    text-align: center;\n                                    font-size: 0.5em;\n                                    background-color: $ideate-color;\n                                    color: #fff;\n                                    margin-left: 4px;\n                                    border-radius: 50%;\n                                    vertical-align: bottom;\n                                    position: relative;\n                                    top: -1px;\n\n                                    @media only screen and (max-width: 630px) {\n                                        position: absolute;\n                                        top: auto;\n                                        bottom: -2px;\n                                        right: 0;\n                                        margin: 0;\n                                    }\n                                }\n\n                                &:hover {\n                                    color: $ideate-color;\n                                    opacity: 1;\n                                }\n\n                                &:hover>span.card__topcount {\n                                    color: $ideate-color;\n                                    background-color: #efefef;\n                                    opacity: 1;\n                                }\n                            }\n                        }\n                    }\n                }\n\n                &--ctt {\n                    position: relative;\n\n                    ul {\n                        li {\n                            .card-body__tooltip {\n                                display: none;\n                                position: absolute;\n                                background: #fff;\n                                color: #676a6c;\n                                padding: 5px;\n                                top: -27px;\n                                box-shadow: 0 0 10px rgb(0 0 0 / 20%);\n                                border-radius: 5px;\n\n                            }\n\n                            button {\n\n                                &:hover {\n                                    opacity: 0.2 !important;\n                                }\n\n                            }\n\n                            &:hover,\n                            &:active {\n\n                                .card-body__tooltip {\n                                    display: block;\n                                }\n                            }\n\n                            // &:hover .card-body__tooltip,\n                            // &:active .card-body__tooltip {\n                            //     display: block;\n\n                            // }\n\n                        }\n                    }\n                }\n\n            }\n\n            .card__h3button {\n                border: 1px solid $ideate-color;\n                background-color: transparent;\n                padding: 4px 26px;\n                border-radius: 3px;\n                @include headingfont();\n                color: $ideate-color;\n                font-size: 22px;\n                line-height: 1.2;\n                @include transition-slow();\n                cursor: pointer;\n\n                &:hover {\n                    background-color: $ideate-color;\n                    color: #fff;\n                }\n\n                &:focus {\n                    outline: none;\n                }\n            }\n\n            .tooltipicon {\n                cursor: pointer;\n                position: relative;\n                font-size: 18px;\n                display: inline-block;\n\n                i {\n                    color: $ideate-color;\n                }\n\n                &:hover>i>.tooltiptext {\n                    visibility: visible;\n                }\n\n                .tooltiptext {\n                    visibility: hidden;\n                    width: 250px;\n                    background-color: #fff;\n                    color: $ideate-color;\n                    text-align: center;\n                    border-radius: 6px;\n                    padding: 10px;\n                    box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);\n                    font-size: 13px;\n                    font-family: 'Open Sans', sans-serif;\n                    line-height: 1.5;\n                    position: absolute;\n                    top: 15px;\n                    right: 10px;\n                    z-index: 1;\n                }\n            }\n        }\n\n        h3 {\n            font-size: 20px;\n            margin: 0;\n            cursor: pointer;\n            color: $ideate-color;\n            @include headingfont();\n            @include fflex();\n            @include fflex-aic();\n\n            @media #{$mq-md} {\n                font-size: 16px;\n            }\n\n            @media #{$mq-sm} {\n                font-size: 15px;\n                word-break: break-word;\n            }\n\n            &>*:not(:last-child) {\n                margin-right: 5px;\n            }\n\n            .card__bwnh3pencil {\n\n                a {\n                    color: $ideate-color;\n                }\n            }\n\n            .card__bwnh3button {\n\n                @media #{$mq-sm} {\n                    width: 100%;\n                    margin-top: 10px;\n                }\n\n                button {\n                    font-size: 18px !important;\n                    padding-right: 15px !important;\n                    padding-left: 15px !important;\n\n                    @media #{$mq-sm} {\n                        font-size: 16px !important;\n                    }\n                }\n            }\n\n            i {\n                cursor: pointer;\n                font-size: 0.9em;\n\n                &+div {\n                    padding-left: 7px;\n\n                    span {\n                        display: block;\n                        font-size: 0.7em;\n                    }\n                }\n\n                &+span {\n                    padding-left: 7px;\n                }\n            }\n\n        }\n\n        .tooltipicon {\n            position: relative;\n            font-size: 18px;\n            display: inline-block;\n\n            i {\n                color: $ideate-color;\n            }\n\n            &:hover>i>.tooltiptext {\n                visibility: visible;\n            }\n\n            .tooltiptext {\n                visibility: hidden;\n                width: 250px;\n                background-color: #fff;\n                color: $ideate-color;\n                text-align: center;\n                border-radius: 6px;\n                padding: 10px;\n                box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);\n                font-size: 13px;\n                font-family: 'Open Sans', sans-serif;\n                line-height: 1.5;\n                position: absolute;\n                top: 15px;\n                right: 10px;\n                z-index: 1;\n            }\n        }\n    }\n\n    app-ideate-ideas,\n    app-ideate-challenge-top-ideas {\n        display: block;\n        margin-top: 30px;\n    }\n\n    .card-default {\n        &.card-default--summary {\n            box-shadow: none;\n\n            .info {\n                border-top: 0;\n                border-right: 0;\n                border-left: 0;\n                padding-right: 20px;\n                padding-left: 20px;\n            }\n\n            .card-body {\n                border-right: 0;\n                border-bottom: 0;\n                border-left: 0;\n                border-radius: 0;\n\n                &__inner {\n                    padding-right: 20px;\n                    padding-left: 20px;\n                }\n            }\n\n            &+div {\n                margin-top: 20px;\n            }\n        }\n\n        &+div {\n            margin-top: 30px;\n        }\n\n        .info {\n            margin: 0;\n            border: 1px solid $ideate-color;\n            border-radius: 6px;\n\n            &.card__headactive {\n                border-bottom-right-radius: 0;\n                border-bottom-left-radius: 0;\n\n                &--cc {\n                    background-color: $ideate-color;\n\n                    .card__topcol {\n                        h3 {\n                            color: #fff;\n                        }\n\n                        ul {\n                            li {\n\n                                button {\n                                    border-color: #fff;\n                                    background-color: #fff;\n\n                                    span {\n                                        color: $ideate-color;\n                                        background-color: #fff;\n                                    }\n\n                                    .st0 {\n                                        fill: #fff !important;\n                                    }\n                                }\n                            }\n                        }\n                    }\n\n                    i {\n                        color: #fff;\n                    }\n                }\n            }\n        }\n\n        border-radius: 6px;\n        border-top-width: 3px;\n        border: 0;\n        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);\n\n        .card-body__inner {\n            padding: 15px 40px;\n            height: auto;\n            overflow-y: auto;\n\n            @media #{$mq-md} {\n                padding: 12px 20px;\n            }\n        }\n\n        .card-body {\n            display: none;\n            border: 1px solid $cn-border-color;\n            border-top: 0;\n            border-radius: 0 0 6px 6px;\n            overflow: hidden;\n\n            &.card-show {\n                display: block;\n\n                &__wbg {\n                    background-color: #fff;\n                }\n\n            }\n\n            .hideblk {\n                display: none;\n            }\n\n            &__finalstate {\n                p {\n                    font-size: 15px;\n                    font-weight: 600;\n\n                    @media #{$mq-sm} {\n                        font-size: 13px;\n                    }\n\n                    &:last-child {\n                        margin-bottom: 0;\n                    }\n                }\n\n                &--2 {\n                    margin: 0 -10px;\n\n                    &>div {\n                        width: calc(100% / 2);\n                        padding: 0 10px;\n\n                        @media only screen and (max-width: 767px) {\n                            width: 100%;\n                        }\n\n                        p {\n                            position: relative;\n                            padding-left: 10px;\n\n                            &::before {\n                                content: \"\";\n                                position: absolute;\n                                top: 8px;\n                                left: 0;\n                                width: 5px;\n                                height: 5px;\n                                border-radius: 50%;\n                                background-color: #444;\n                            }\n                        }\n                    }\n                }\n            }\n\n            &__subtitle {\n                padding-left: 35px;\n                margin-bottom: 16px;\n                position: relative;\n\n                *:last-child {\n                    margin-bottom: 0;\n                }\n\n                &>span {\n                    position: absolute;\n                    top: 0;\n                    right: 2px;\n                    opacity: 0.7;\n                    cursor: pointer;\n\n                    &.thinkeyebtn {\n                        right: 0px;\n                    }\n\n                }\n\n                &--pl0 {\n                    padding-left: 0;\n                }\n\n                p {\n                    color: #969798;\n                    font-size: 15px;\n\n                    i {\n                        padding-left: 5px;\n                    }\n                }\n            }\n        }\n\n        .c-radio {\n            label {\n                padding-left: 0;\n            }\n\n            input {\n                opacity: 0;\n                margin: 0;\n\n                &+span {\n                    position: relative;\n                    display: inline-block;\n                    vertical-align: top;\n                    width: 20px;\n                    height: 20px;\n                    border-radius: 50%;\n                    border: 1px solid #ccc;\n                    margin-right: 5px;\n                    text-align: center;\n\n                    &::before {\n                        position: absolute;\n                        color: $ideate-color;\n                        opacity: 0;\n                        font-size: 11px;\n                        top: 50%;\n                        left: 50%;\n                        -webkit-transform: translate(-50%, -50%);\n                        -ms-transform: translate(-50%, -50%);\n                        transform: translate(-50%, -50%);\n                    }\n                }\n\n                &:checked {\n                    &+span {\n                        border-color: $ideate-color;\n                    }\n\n                    &+span::before {\n                        opacity: 1;\n                    }\n                }\n            }\n        }\n\n        .checkbox {\n            margin-top: 0;\n\n            label {\n                min-height: 20px;\n                padding-left: 0;\n                margin-bottom: 0;\n                font-weight: 400;\n                cursor: pointer;\n                width: 100% !important;\n                font-size: 15px;\n                font-weight: bold;\n                color: #676a6c;\n\n                &>i {\n                    position: relative;\n                    top: 1px;\n                    margin-right: 6px;\n                }\n\n                &>span {\n                    vertical-align: middle;\n                }\n            }\n\n            input {\n                opacity: 0;\n                position: absolute;\n                display: none;\n\n                &+span {\n                    position: relative;\n                    display: inline-block;\n                    vertical-align: top;\n                    width: 20px;\n                    height: 20px;\n                    border-radius: 2px;\n                    border: 1px solid #ccc;\n                    margin-right: 10px;\n                    text-align: center;\n                    vertical-align: middle;\n\n                    &::before {\n                        font-size: 12px;\n                        position: absolute;\n                        color: #fff;\n                        opacity: 0;\n                        top: 50%;\n                        left: 50%;\n                        -webkit-transform: translate(-50%, -50%);\n                        -ms-transform: translate(-50%, -50%);\n                        transform: translate(-50%, -50%);\n                    }\n                }\n\n                &:checked {\n                    &+span {\n                        border-color: $ideate-color;\n                        background-color: $ideate-color;\n                    }\n\n                    &+span::before {\n                        opacity: 1;\n                    }\n                }\n            }\n        }\n\n        .card-body__button {\n            background-color: #f5f5f5;\n            border-top: 1px solid #e3e3e3;\n            padding: 12px 40px;\n\n            .card-button {\n                @include fflex();\n                @include fflex-aic();\n\n                .btn {\n                    border-radius: 3px;\n                    font-size: 14px;\n                    font-weight: bold;\n                    text-align: center;\n                    @include transition-slow();\n\n                    &+.btn {\n                        margin-left: 15px;\n                    }\n\n                    em {\n                        margin-right: 6px;\n                        font-size: 0.8em;\n                    }\n                }\n\n                .float-right {\n                    margin-left: auto;\n                }\n\n                .btn-ideate {\n                    background-color: $ideate-color;\n                    border-color: $ideate-color;\n                    color: #fff;\n\n                    &:hover {\n                        background-color: $ideate-color;\n                        border-color: $ideate-color;\n                    }\n                }\n\n                .btn-success {\n                    background-color: #27c24c;\n                    border-color: #27c24c;\n\n                    &:hover {\n                        background-color: #21A240;\n                        border-color: #1E983B;\n                    }\n                }\n\n                .btn-danger {\n                    background-color: #fff;\n                    border-color: #fff;\n                    color: #ef6272;\n\n                    &:hover {\n                        background-color: #ED2D2D;\n                        border-color: #EC2121;\n                    }\n                }\n\n                .btn-warning {\n                    em {\n                        margin: 0;\n                    }\n                }\n\n                .btn-deleteall {\n                    border: 0;\n                    background-color: transparent;\n                    position: relative;\n                    overflow: hidden;\n                    box-shadow: none;\n                    padding-right: 0;\n                    padding-left: 0;\n                    @include transition-slow();\n\n                    span {\n                        position: absolute;\n                        left: 110%;\n                        @include transition-slow();\n                    }\n\n                    &:hover {\n                        background-color: #fff;\n                        color: #ed5562;\n                        padding-right: 16px;\n                        padding-left: 16px;\n\n                        &>span {\n                            position: relative;\n                            left: 0;\n                        }\n\n                        em {\n                            margin-right: 6px;\n                        }\n                    }\n\n                    em {\n                        font-size: 1em;\n                        margin-right: 0;\n                        @include transition-slow();\n                    }\n                }\n            }\n        }\n\n        .card-body--ebtn {\n            margin-top: 15px;\n            padding: 15px 40px;\n            border-top: 1px solid $cn-border-color;\n\n\n            @media #{$mq-md} {\n                padding: 12px 20px;\n            }\n\n            .card-body--ebtnrow {\n                margin: 0 -8px;\n                @include fflex();\n                @include fflex-aic();\n\n                &>div {\n                    padding: 0 8px;\n\n                    @media #{$mq-sm} {\n                        width: 100%;\n                        text-align: center;\n\n                        &+div {\n                            margin-top: 10px;\n                        }\n                    }\n\n                    &.card-body--col {\n                        &--last {\n                            margin-left: auto;\n                        }\n                    }\n                }\n\n                .btn {\n                    border-radius: 3px;\n                    font-size: 14px;\n                    font-weight: bold;\n                    padding: 7px 16px;\n                    text-align: center;\n                    transition: all ease 0.3s;\n\n                    @media #{$mq-md} {\n                        font-size: 12px;\n                    }\n\n                    i,\n                    em {\n                        margin-right: 6px;\n                        font-size: 0.8em;\n                    }\n\n                    &--save {\n                        background-color: $develop-color;\n                        color: #fff;\n                    }\n\n                    &--clarify {\n                        background-color: $clarify-color;\n                        color: #fff;\n                    }\n\n                    &--ideate {\n                        background-color: $ideate-color;\n                        color: #fff;\n                        border-color: $ideate-color;\n                        font-weight: 900;\n                    }\n\n                    &--disable {\n                        opacity: 0.5;\n                    }\n\n                    &--tracking {\n                        background-color: #6d6e71;\n                        color: #fff;\n                        border-color: #6d6e71;\n                    }\n\n                    &--cancel {\n                        padding: 0;\n                        background-color: transparent;\n                        margin-left: 0;\n                        color: $body-content-color;\n                        border: 0;\n                        font-family: $font-stack;\n                        font-size: 14px;\n                        font-weight: 700;\n\n                        &:hover {\n                            color: #000;\n                        }\n                    }\n\n                    &--tracking {\n                        background-color: #6d6e71;\n                        color: #fff;\n                    }\n\n                    &--converge {\n                        padding: 0 8px;\n                    }\n\n                    &--deleteall {\n                        border: 0;\n                        background-color: transparent;\n                        position: relative;\n                        overflow: hidden;\n                        box-shadow: none;\n                        padding-right: 0;\n                        padding-left: 0;\n\n                        i {\n                            font-size: 14px;\n                            color: $body-content-color;\n                        }\n\n                        @include transition-slow();\n\n                        span {\n                            position: absolute;\n                            left: 110%;\n                            @include transition-slow();\n                        }\n\n                        &:hover {\n                            background-color: #f5f5f5;\n                            color: #ed5562;\n                            padding-right: 16px;\n                            padding-left: 16px;\n\n                            @media #{$mq-sm} {\n                                padding-right: 7px;\n                                padding-left: 7px;\n                            }\n\n                            &>span {\n                                position: relative;\n                                left: 0;\n                            }\n\n                            em {\n                                margin-right: 6px;\n                            }\n                        }\n\n                        @media #{$mq-sm} {\n                            background-color: #f5f5f5;\n                            color: #ed5562;\n                            padding-right: 16px;\n                            padding-left: 16px;\n\n                            @media #{$mq-sm} {\n                                padding-right: 7px;\n                                padding-left: 7px;\n                            }\n\n                            &>span {\n                                position: relative;\n                                left: 0;\n                            }\n\n                            em {\n                                margin-right: 6px !important;\n                            }\n                        }\n\n                        em {\n                            font-size: 1em;\n                            margin-right: 0;\n                            @include transition-slow();\n                        }\n                    }\n                }\n            }\n        }\n\n\n        .note-3 {\n            padding: 15px 15px 10px;\n            border: 2px solid $ideate-color;\n            margin-bottom: 15px;\n\n            label {\n                color: $ideate-color;\n            }\n        }\n\n        .footer-line {\n            color: $ideate-color;\n        }\n\n        p {\n            font-size: 15px;\n\n            &:last-child {\n                margin-bottom: 0;\n            }\n        }\n\n        .card-body__edit {\n            position: relative;\n\n            .breakthrough-input-tabs,\n            .brainstorm-input-tabs {\n                width: 100%;\n                margin-right: 0;\n                position: relative;\n\n                input,\n                select {\n                    height: 45px;\n                    padding: 5px 15px;\n                    border: 1px solid $color-neutral-mid;\n                    border-radius: 4px;\n                    font-size: 15px;\n                }\n            }\n\n            .card-body__editrow {\n                margin: 0 -15px;\n                @include fflex();\n\n                &>div {\n                    padding: 0 15px;\n                    width: 100%;\n                    margin-bottom: 15px;\n\n                    &>div {\n                        position: relative;\n                    }\n                }\n\n                .proposed-challenge {\n                    margin-top: 10px;\n                    font-family: 'Open Sans', sans-serif;\n                    font-size: 15px;\n\n                    label {\n                        padding-bottom: 4px;\n                    }\n                }\n\n                select {\n                    -webkit-appearance: none;\n                    -moz-appearance: none;\n                    appearance: none;\n                    background-image: url($assets+'/images/select.png');\n                    background-size: 10px;\n                    background-position: right 10px center;\n                    background-repeat: no-repeat;\n                }\n\n                textarea {\n                    width: 100%;\n                    border: 1px solid $color-neutral-mid;\n                    resize: none;\n                    border-radius: 3px;\n                    padding: 10px 15px;\n                    font-size: 15px;\n                }\n\n                .breakthrough-input-tabs,\n                .breakthrough-input-tabs {\n                    @include fflex();\n\n                    &>.card-body__editlabel {\n                        width: 35px;\n                        padding-right: 15px;\n                        @include fflex();\n                        @include fflex-aic();\n                    }\n\n                    &>.card-body__editnumber {\n                        width: 40px;\n                        text-align: center;\n                        @include fflex();\n                        @include fflex-aic();\n                        @include fflex-jcc;\n                        border-right: 0;\n                        border-radius: 4px 0 0 4px;\n\n                        &+.card-body__editinput {\n                            width: calc(100% - 41px);\n                            padding-right: 60px;\n\n                            &--ce {\n                                position: relative;\n\n                                .converge-icon {\n                                    position: absolute;\n                                    top: 50%;\n                                    transform: translateY(-50%);\n                                    left: 7px;\n                                    font-size: 26px;\n                                    color: $ideate-color;\n\n                                    &:hover>.card-body__tooltip,\n                                    &:active>.card-body__tooltip {\n                                        display: block;\n                                    }\n\n                                    .card-body__tooltip {\n                                        display: none;\n                                        font-size: 16px;\n                                        color: #676a6c;\n                                        position: absolute;\n                                        bottom: 100%;\n                                        left: 0;\n                                        background: #fff;\n                                        padding: 5px;\n                                        border-radius: 5px;\n                                        box-shadow: 0 0 10px rgb(0 0 0 / 20%);\n                                        width: max-content;\n                                    }\n                                }\n\n                                input {\n                                    padding-left: 26px;\n\n\n                                }\n\n                            }\n                        }\n\n                        label {\n                            font-weight: 900;\n                        }\n                    }\n\n                    &>.card-body__editselect {\n                        width: 315px;\n                        padding-right: 15px;\n                    }\n\n                    &>.card-body__editinput {\n                        width: calc(100% - 351px);\n\n                        input {\n                            padding-right: 70px;\n\n                            &:focus,\n                            &:focus-visible {\n                                outline: none;\n                            }\n                        }\n\n                        .card-body__minus {\n\n                            &--hide {\n                                display: none;\n                            }\n                        }\n                    }\n\n                    &>.card-body__editinput:only-child {\n                        width: 100%;\n                    }\n                }\n            }\n\n            &+.card-body__addnew {\n\n                button {\n                    margin: 0 39px;\n                    font-size: 14px;\n                    font-weight: bold;\n                    background-color: transparent;\n                    border: 1px solid transparent;\n                    padding-right: 0;\n                    padding-left: 0;\n                    color: $body-content-color;\n                    @include transition-slow();\n\n                    &:hover {\n                        background-color: $ideate-color;\n                        border: 1px solid $ideate-color;\n                        color: #fff;\n                        padding-right: 12px;\n                        padding-left: 12px;\n                    }\n                }\n            }\n        }\n\n        .input-tabs {\n            &+i {\n                position: relative;\n                top: -1px;\n            }\n\n            display: -webkit-inline-box;\n            display: -ms-inline-flexbox;\n            display: inline-flex;\n            @include fflex-aic();\n            width: calc(100%);\n            padding: 0 0 0 0;\n            margin: 0;\n\n\n\n\n            .select_faded {\n                opacity: 0.2;\n                padding-left: 32px;\n            }\n\n            input,\n            select {\n                height: 45px;\n                padding: 5px 15px;\n                border: 1px solid #e3e3e3;\n                border-radius: 4px;\n                margin: 7px 0px;\n            }\n\n            label {\n                width: 20px;\n                margin: 0;\n            }\n\n            select {\n                width: 9%;\n            }\n\n            input {\n                width: 90%;\n                margin-left: 15px;\n            }\n        }\n\n        .input-group-text {\n            cursor: pointer;\n            padding: 3px 16px;\n            margin-bottom: 0;\n            font-size: 14px;\n            font-weight: 400;\n            line-height: 1.528571429;\n            color: #495057;\n            text-align: center;\n            white-space: nowrap;\n            background-color: #E9ECEF;\n            border: 1px solid #DDE6E9;\n            border-radius: 0.25rem;\n            position: absolute;\n            top: calc(50% + 1px);\n            right: 0;\n            -webkit-transform: translateY(-50%);\n            -ms-transform: translateY(-50%);\n            transform: translateY(-50%);\n            @include transition-slow();\n\n            &:hover {\n                background-color: $ideate-color;\n                border-color: $ideate-color;\n                color: #fff;\n            }\n        }\n\n        .list-columns {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            -ms-flex-wrap: wrap;\n            flex-wrap: wrap;\n            counter-reset: section;\n\n            &>div {\n                &.card__body--cswrapper {\n                    width: 100%;\n                    position: relative;\n                    border-bottom: 1px solid #e4e4e4;\n                    padding-bottom: 5px;\n                    margin-bottom: 10px;\n\n                    // & > div {\n                    // }\n                    &::before,\n                    &::after {\n                        content: \"\";\n                        position: absolute;\n                        bottom: -1px;\n                        right: calc(100%);\n                        width: 40px;\n                        height: 1px;\n                        background-color: #e4e4e4;\n                    }\n\n                    &::after {\n                        right: auto;\n                        left: calc(100%);\n                    }\n                }\n            }\n\n            &.list-columns--2 {\n                &>div {\n                    width: 100%;\n                }\n            }\n\n            .brainstorm-tabs {\n                position: relative;\n                padding-left: 23px;\n\n                &::before {\n                    counter-increment: section;\n                    content: counter(section) \".\";\n                    position: absolute;\n                    top: 0;\n                    left: 0;\n                }\n            }\n        }\n    }\n\n    .idea-shop-list {\n        padding: 20px;\n        margin-left: 17px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n\n        li {\n            width: calc(100% / 2);\n            margin-bottom: 10px;\n        }\n    }\n\n    .brainstorm__col {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        margin-bottom: 17px;\n\n        .brainstorm-main {\n            width: calc(100% - 68px);\n            display: inline-block;\n            margin-right: 20px;\n\n            .brainstorm-group {\n                width: 100%;\n                position: relative;\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                -ms-flex-wrap: wrap;\n                flex-wrap: wrap;\n\n                .input-group-prepend {\n                    margin-right: -1px;\n                    width: 45px;\n\n                    .input-group-text {\n                        background: transparent;\n                        border-color: $ideate-color;\n                        height: 35px;\n                        padding: 0;\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                        align-items: center;\n                        -webkit-box-pack: center;\n                        -ms-flex-pack: center;\n                        justify-content: center;\n                    }\n                }\n\n                input {\n                    width: calc(100% - 45px);\n                    height: 35px;\n                    border: 1px solid $ideate-color;\n                    border-radius: 0 0.25rem 0.25rem 0;\n                }\n            }\n        }\n    }\n\n    .card-bottom-button {\n        .button {\n            font-size: 13px;\n            color: #fff;\n            padding: 8px 10px;\n            border-radius: 3px;\n            -webkit-transition: all ease 0.3s;\n            -o-transition: all ease 0.3s;\n            transition: all ease 0.3s;\n\n            &:hover {\n                opacity: .8;\n            }\n\n            i {\n                font-size: 0.8em;\n            }\n\n            &.btn-clarify {\n                background-color: $clarify-color;\n            }\n\n            &.btn-ideate {\n                background-color: $ideate-color;\n            }\n\n            &.btn-implement {\n                background-color: $implement-color;\n            }\n        }\n    }\n\n    .dotactions {\n        position: relative;\n\n        .dotactions__inner {\n            position: absolute;\n            top: 0;\n            right: 0;\n\n            &--h {\n                top: 5px;\n\n                .dotactions__top {\n                    cursor: pointer;\n                    width: 17px;\n                    -webkit-box-pack: justify;\n                    -ms-flex-pack: justify;\n                    justify-content: space-between;\n                }\n            }\n\n            &--v {\n                right: 10px;\n                top: 11px;\n\n                .dotactions__top {\n                    cursor: pointer;\n                    -webkit-box-orient: vertical;\n                    -webkit-box-direction: normal;\n                    -ms-flex-direction: column;\n                    flex-direction: column;\n                    -webkit-box-pack: justify;\n                    -ms-flex-pack: justify;\n                    justify-content: space-between;\n                    height: 21px;\n                    width: 11px;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    align-items: center;\n                }\n            }\n\n            .dotactions__top {\n                padding-bottom: 4px;\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                -ms-flex-wrap: wrap;\n                flex-wrap: wrap;\n\n                span {\n                    background-color: #adadad;\n                    width: 3px;\n                    height: 3px;\n                    border-radius: 50%;\n                }\n            }\n\n            .dotactions__dropdown {\n                display: none;\n                background-color: #fff;\n                position: absolute;\n                top: 100%;\n                width: 150px;\n                box-shadow: 0 0 20px rgba(0, 0, 0, 0.04);\n                right: -5px;\n                border-radius: 4px;\n                z-index: 9;\n                border: 1px solid #ddd;\n\n                .dotactions__close {\n                    cursor: pointer;\n                    position: absolute;\n                    top: 5px;\n                    right: 6px;\n                    font-size: 11px;\n                    -webkit-transition: all ease 0.3s;\n                    -o-transition: all ease 0.3s;\n                    transition: all ease 0.3s;\n\n                    &:hover {\n                        -webkit-transform: rotate(360deg);\n                        -ms-transform: rotate(360deg);\n                        transform: rotate(360deg);\n                    }\n                }\n\n                .dotactions__dropdowninner {\n                    display: none;\n                    position: absolute;\n                    top: 0;\n                    right: 0;\n                    width: 200px;\n                    box-shadow: 0 0 20px rgba(0, 0, 0, 0.04);\n                    border-radius: 4px;\n                    padding: 18px;\n                    background: #fff;\n                    border: 1px solid #ddd;\n\n                    .dotactions__dropdownin {\n                        padding: 10px 10px;\n                        border-radius: 4px;\n                        min-height: 100%;\n                        background-color: #f4f4f4;\n\n                        h6 {\n                            margin: 0;\n                            font-size: 13px;\n                            font-weight: 600;\n                            margin-bottom: 6px;\n                        }\n                    }\n                }\n\n                &>h6 {\n                    text-align: center;\n                    margin: 0;\n                    font-size: 13px;\n                    padding: 8px 10px;\n                    border-bottom: 1px solid #eee;\n                    font-weight: 400;\n                    margin-bottom: 2px;\n                    background-color: #f4f4f4;\n                }\n\n                li {\n                    margin: 0;\n\n                    a {\n                        padding: 6px 12px;\n                        color: #656565;\n                        display: block;\n                        font-weight: 400;\n\n                        &:hover {\n                            background-color: rgba(9, 30, 66, .04);\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .card-body__ip {\n        .card-body__ipwrap {\n            padding: 4px 0 80px;\n            overflow-x: auto;\n            margin: 0 0 10px;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            -ms-flex-wrap: nowrap;\n            flex-wrap: nowrap;\n\n            .card-body__ipcol {\n                padding: 0;\n                margin-bottom: 0px;\n                max-width: 285px;\n                width: 100%;\n                flex: 0 0 285px;\n                -webkit-flex: 0 0 285px;\n                -ms-flex: 0 0 285px;\n\n                .checkbox {\n                    padding-right: 22px;\n                }\n\n                &+div {\n                    margin-left: 30px;\n                }\n\n                @media only screen and (max-width: 1080px) {\n                    width: calc(100% / 2);\n                }\n\n                @media only screen and (max-width: 600px) {\n                    width: calc(100%);\n                }\n\n                .card-body__ipaddcol {\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    -ms-flex-wrap: wrap;\n                    flex-wrap: wrap;\n\n                    &>.form-control {\n                        width: calc(100% - 91px);\n                        border: 1px solid #ccc;\n                        border-radius: 4px 0 0 4px;\n                    }\n\n                    .input-group-postpend {\n                        width: 90px;\n\n                        button {\n                            background-color: $ideate-color;\n                            box-shadow: none;\n                            color: #fff;\n                            border-color: $ideate-color;\n                            font-family: $font-stack;\n                        }\n\n                        &--ro {\n                            opacity: 0.4;\n                        }\n                    }\n                }\n            }\n\n            h2 {\n                margin-top: 0;\n                color: #656565;\n                font-size: 14px;\n                font-weight: 500;\n                margin-bottom: 12px;\n\n                label {\n                    display: inline-block;\n                    padding-right: 2px;\n                    width: auto !important;\n                }\n\n                input[type=\"checkbox\"] {\n                    opacity: 0;\n                    position: absolute;\n\n                    &+span {\n                        position: relative;\n                        top: -2px;\n                        margin: 0 5px 0 0;\n                        display: inline-block;\n                        vertical-align: top;\n                        width: 20px;\n                        height: 20px;\n                        border-radius: 2px;\n                        border: 1px solid #ccc;\n                        text-align: center;\n\n                        &::before {\n                            position: absolute;\n                            color: #fff;\n                            opacity: 0;\n                            top: 50%;\n                            left: 50%;\n                            -webkit-transform: translate(-50%, -50%);\n                            -ms-transform: translate(-50%, -50%);\n                            transform: translate(-50%, -50%);\n                        }\n                    }\n\n                    &:checked+span {\n                        background-color: $ideate-color;\n                        border-color: $ideate-color;\n                    }\n\n                    &:checked+span::before {\n                        opacity: 1;\n                    }\n                }\n            }\n\n            .dotactions__editinput {\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                -ms-flex-wrap: wrap;\n                flex-wrap: wrap;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                align-items: center;\n\n                &>div:first-child {\n                    margin-right: 10px;\n                    width: 73%;\n\n                    input:focus {\n                        border-color: $ideate-color;\n                        outline: $ideate-color;\n                    }\n                }\n\n                &>div:nth-child(2) {\n                    margin-left: auto;\n                }\n\n                &>div:nth-child(3) {\n                    margin-left: 10px;\n                }\n\n                &>div {\n                    i {\n                        font-size: 17px;\n                        color: #ff0000;\n                        cursor: pointer;\n                    }\n                }\n\n                .topidea__btn {\n                    padding: 3px 5px;\n                    font-size: 12px;\n                    color: #fff;\n                    background-color: $develop-color;\n                }\n            }\n\n            ul {\n                padding: 0;\n                margin: 0;\n                min-height: 10px;\n\n                li {\n                    list-style: none;\n                    padding: 0;\n                    width: 100%;\n\n                    .card-body__ipinner {\n                        display: block;\n                        font-weight: 400;\n                        position: relative;\n                        border: 1px solid #ccc;\n                        padding: 10px;\n                        border-radius: 5px;\n                    }\n                }\n            }\n        }\n    }\n}\n\n.tooltippopup {\n    max-width: 360px;\n    width: 100%;\n    height: 100%;\n    background: #fff;\n    position: fixed;\n    top: 0;\n    right: -550px;\n    padding: 45px 24px 24px;\n    text-align: left;\n    z-index: 9999;\n    box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);\n    @include transition-slow();\n    overflow-y: auto;\n\n    &--active {\n        right: 0;\n    }\n\n    &--videoexist {\n        max-width: 735px;\n    }\n\n    &__btn {\n        @include fflex();\n        padding: 0;\n        margin: 0 0 10px;\n\n        li {\n            list-style: none;\n            text-align: center;\n            cursor: pointer;\n            width: calc(100% / 3);\n\n            button {\n                width: 100%;\n                color: $ideate-color;\n                font-size: 12px;\n                padding: 6px 16px;\n                @include headingfont();\n                display: inline-block;\n                height: 100%;\n                border: 0;\n                border: 1px solid $ideate-color;\n                background-color: transparent;\n                transition: all ease 0.3s;\n                @include appearance-none();\n\n                &:focus {\n                    outline: none;\n                }\n\n                &.tooltippopup__btncompleted {\n                    opacity: 0.2;\n\n                    &:hover {\n                        opacity: 1;\n                    }\n                }\n\n                &.tooltippopup__btnactive {\n                    opacity: 1;\n                }\n\n                &:hover {\n                    position: relative;\n                    z-index: 9;\n                }\n            }\n\n            &+li {\n                margin-left: -1px;\n            }\n\n            &:first-child {\n                button {\n                    border-radius: 3px 0 0 3px\n                }\n            }\n\n            &:last-child {\n                button {\n                    border-radius: 0 3px 3px 0;\n                }\n            }\n        }\n    }\n\n    h4 {\n        color: #676a6c;\n        margin: 0 0 10px;\n        font-size: 16px;\n        line-height: 1.2;\n    }\n\n    p {\n        color: #676a6c;\n        margin: 0 0 10px;\n        font-size: 14px;\n        line-height: 1.4;\n    }\n\n    &__close {\n        position: absolute;\n        top: 10px;\n        right: 25px;\n        width: 18px;\n        height: 18px;\n        cursor: pointer;\n        @include transition-slow();\n\n        &:hover {\n            -webkit-transform: rotate(360deg);\n            -ms-transform: rotate(360deg);\n            transform: rotate(360deg);\n        }\n\n        &>div {\n            position: absolute;\n            top: 0;\n            left: 0;\n            width: 100%;\n            height: 100%;\n            -webkit-transform: rotate(45deg);\n            -ms-transform: rotate(45deg);\n            transform: rotate(45deg);\n\n            span {\n                position: absolute;\n                background: #676a6c;\n\n                &:nth-child(1) {\n                    top: 0;\n                    left: calc(50% - 1px);\n                    width: 2px;\n                    height: 100%;\n                }\n\n                &:nth-child(2) {\n                    top: calc(50% - 1px);\n                    left: 0;\n                    width: 100%;\n                    height: 2px;\n                }\n            }\n        }\n    }\n\n    &__child {\n        margin-top: 20px;\n\n        &data {\n            .table-responsive {\n                overflow-x: auto;\n                margin-bottom: 10px;\n\n                table {\n                    min-width: 297px;\n                    border: 1px solid #e7eaec;\n\n                    th,\n                    td {\n                        border: 1px solid #e7eaec;\n                        min-width: 120px;\n                    }\n                }\n\n                &+* {\n                    margin-top: 20px;\n                }\n            }\n\n            &--clarify {\n                h4 {\n                    color: $clarify-color;\n                }\n            }\n\n            &--ideate {\n                h4 {\n                    color: $ideate-color;\n                }\n            }\n\n            &--develop {\n                h4 {\n                    color: $develop-color;\n                }\n            }\n\n            &--implement {\n                h4 {\n                    color: $implement-color;\n                }\n            }\n\n            h4 {\n                font-size: 16px;\n                font-weight: 500;\n                margin: 0 0 2px;\n                @include headingfont();\n\n                &+h5 {\n                    mask-type: 10px;\n                }\n            }\n\n            p {\n                margin-bottom: 5px;\n                line-height: 1.3;\n\n                &:last-child {\n                    margin-bottom: 0;\n                }\n            }\n\n            &+div {\n                margin-top: 17px;\n            }\n        }\n    }\n\n    &__links {\n        padding: 0;\n        margin: 0;\n\n        li {\n            list-style: none;\n            width: 100%;\n\n            a {\n                position: relative;\n                color: $ideate-color;\n                @include transition-slow();\n                // &::before {\n\n                // }\n                &:hover {\n                    opacity: 0.75;\n                }\n            }\n\n            &+li {\n                margin-top: 4px;\n\n            }\n        }\n    }\n}\n\n\n\n.popaccordian {\n    &__row {\n        &head {\n            position: relative;\n            cursor: pointer;\n            border: 1px solid $ideate-color;\n            padding: 9px;\n            border-radius: 3px;\n            @include fflex();\n\n            &arrow {\n                position: absolute;\n                top: 0;\n                left: 0;\n            }\n\n            h5 {\n                margin: 0;\n                position: relative;\n                color: $ideate-color;\n                padding-left: 10px;\n                @include headingfont();\n\n                i {\n                    @include transition-slow();\n                }\n            }\n        }\n\n        &body {\n            border: 1px solid $ideate-color;\n            border-top: 0;\n            display: none;\n            border-radius: 0 0 3px 3px;\n\n            &inner {\n                padding: 10px;\n\n                &>*:last-child {\n                    margin-bottom: 0;\n                }\n\n                h5 {\n                    margin: 0 0 10px;\n                    position: relative;\n                    color: $ideate-color;\n                    @include headingfont();\n                }\n\n                ul {\n                    margin: 0;\n                    padding: 0;\n\n                    li {\n                        list-style: none;\n                        font-size: 14px;\n                        line-height: 1.3;\n                        position: relative;\n                        padding-left: 10px;\n\n                        &::before {\n                            content: \"\";\n                            position: absolute;\n                            top: 7px;\n                            left: 0;\n                            width: 5px;\n                            height: 5px;\n                            border-radius: 50%;\n                            background-color: #444;\n                        }\n\n                        &+li {\n                            margin-top: 5px;\n                        }\n                    }\n                }\n            }\n        }\n\n        &video {\n            margin-top: 20px;\n            padding-bottom: 15px;\n\n            &inner {\n                position: relative;\n                // padding-bottom: 56.25%;\n\n                iframe {\n                    position: absolute;\n                    top: 0;\n                    left: 0;\n                    width: 100% !important;\n                    height: 100% !important;\n                }\n            }\n        }\n\n        &+div {\n            margin-top: 15px;\n        }\n\n        .popaccordian__rowhead {\n            align-items: center;\n            justify-content: space-between;\n        }\n\n        &--active {\n            .popaccordian__rowhead {\n                border-radius: 3px 3px 0 0;\n\n                i {\n                    @include transRotate (90deg);\n                }\n            }\n        }\n\n        &:first-child {\n            .popaccordian__rowbody {\n                display: block;\n            }\n        }\n\n    }\n\n    &__gen {\n        .slctrs {\n            border-bottom: 1.5px solid #F1F1F2;\n        }\n\n        select {\n            width: 100%;\n            border: 1px solid $cn-border-color;\n            padding: 6px;\n            height: 45px;\n            border-radius: 4px;\n        }\n\n        label {\n            display: block;\n        }\n\n        button {\n            background-color: $ideate-color;\n            border-color: $ideate-color;\n        }\n\n        &__aidata {\n            min-height: 400px;\n            position: relative;\n            display: none;\n\n            &--hyt {\n                min-height: auto;\n            }\n        }\n\n        &__addbtn {\n\n            button {\n                background-color: transparent;\n                border: 0;\n\n                &:active {\n                    box-shadow: none;\n                }\n            }\n        }\n    }\n\n}\n\n\n.prevnext {\n    padding: 20px 0;\n\n    &__inner {\n        @include fflex();\n        @include fflex-aic();\n        padding: 0;\n        margin: 0;\n    }\n\n    li {\n        list-style: none;\n\n        &.prevnext__next {\n            margin-left: auto;\n        }\n\n        &.prevnext__prev a {\n            &:hover>i {\n                left: -5px;\n            }\n        }\n\n        &.prevnext__next a {\n            background-color: $ideate-color;\n            color: #fff;\n            opacity: 1;\n            padding: 6px 12px;\n            border-radius: 3px;\n\n            &:hover>i {\n                left: 3px;\n            }\n        }\n\n        a {\n            @include headingfont();\n            font-size: 14px;\n            color: #676a6c;\n            opacity: 0.47;\n            padding: 6px 0;\n            display: inline-block;\n            @include transition-slow();\n\n            i {\n                position: relative;\n                font-size: 1.1em;\n                left: 0;\n                @include transition-slow();\n            }\n        }\n    }\n}\n\n.playbtn {\n    position: absolute;\n    right: 9px;\n    bottom: 7px;\n    color: #06a6ce;\n}\n\n.Del-data-btn {\n    padding: 40px 0;\n\n    .btn {\n        margin-left: 15px;\n        background-color: #fff;\n        border-color: #f5f5f5;\n        color: #ff485c;\n    }\n\n    .cancelbtn {\n        color: #676a6c;\n        text-align: center;\n        font-size: 15px;\n        font-family: \"Open Sans\", sans-serif;\n        line-height: 1.5;\n        padding: 6px;\n    }\n}\n\n\n.editmode {\n    margin-bottom: 30px;\n\n    &--btinp {\n        margin-bottom: 0px;\n    }\n\n    &--sc {\n\n        h3 {\n            color: #676A6C !important;\n        }\n    }\n\n    &__list {\n\n        &row {\n            display: grid;\n            grid-template-columns: repeat(2, 1fr);\n            grid-gap: 15px;\n\n            &--nogap {\n                grid-gap: 0;\n            }\n\n            @media #{$mq-sm} {\n                grid-template-columns: 1fr;\n            }\n\n            &--equalblocks {\n                display: flex;\n                flex-wrap: wrap;\n\n                &>.editmode__listcol {\n                    flex: 1;\n\n                    @media #{$mq-sm} {\n                        flex: none;\n                        width: 100%;\n                    }\n                }\n\n            }\n\n            &--fullblocks {\n                grid-template-columns: 1fr;\n            }\n\n            &--grid {\n                &1 {\n                    grid-template-columns: 1fr;\n                }\n\n                &3 {\n\n                    &>div:nth-child(1) {\n                        grid-row: 1 / 3;\n                    }\n                }\n\n                &4 {\n\n                    &>div:nth-child(1) {\n                        grid-row: 1 / 4;\n                    }\n                }\n\n                &5 {\n\n                    &>div:nth-child(1) {\n                        grid-row: 1 / 5;\n                    }\n                }\n\n                &6 {\n\n                    &>div:nth-child(1) {\n                        grid-row: 1 / 6;\n                    }\n                }\n\n                &7 {\n\n                    &>div:nth-child(1) {\n                        grid-row: 1 / 7;\n                    }\n                }\n            }\n        }\n\n        &cell {\n            padding: 10px 15px;\n            background-color: #EBEBEB;\n            border: 1px solid $cn-border-color;\n            border-radius: 6px;\n            height: 100%;\n\n            &--startbtn {\n                border: 1px solid $ideate-color;\n                // color: $ideate-color;\n                font-weight: 600;\n                font-family: 'Open Sans';\n                font-size: 16px;\n                cursor: pointer;\n                line-height: 1;\n                color: inherit !important;\n            }\n\n            @media #{$mq-sm} {\n                font-size: 13px;\n            }\n\n            h3 {\n                color: $ideate-color;\n                margin-bottom: 5px;\n\n                a,\n                i {\n                    color: inherit;\n                }\n            }\n\n            &--ls {\n                li {\n                    list-style-type: disc;\n                    color: #676a6c;\n                }\n            }\n\n            &--sc {\n                p {\n                    font-weight: normal !important;\n                }\n\n                h3 {\n                    button {\n                        font-family: 'Open Sans';\n                        font-size: 16px;\n                        color: #676a6c;\n                        font-weight: 600;\n                        cursor: pointer;\n                    }\n                }\n            }\n\n            p {\n                font-size: 15px;\n                font-weight: 600;\n\n                @media #{$mq-sm} {\n                    font-size: 13px;\n                }\n\n                &:last-child {\n                    margin-bottom: 0;\n                }\n            }\n        }\n    }\n\n}\n\n.trackInfo {\n    padding: 2px 16px;\n    background-color: #6d6e71;\n    color: #fff;\n    margin-left: 40px;\n    border-radius: 5px;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    font-size: 10px;\n\n    &--inputclr {\n        color: $ideate-color;\n        font-size: 11px;\n        background: transparent;\n        margin-left: 8px;\n        padding-left: 0;\n        margin-bottom: 2px;\n        display: inline-block;\n    }\n}\n\n.loader-container {\n    position: absolute;\n    left: 0;\n    right: 0;\n    text-align: center;\n    top: 0;\n    bottom: 0;\n    background: rgba(236, 236, 236, .9);\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: none;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    z-index: 9999999999;\n    height: 100vh;\n    margin: 0 auto;\n}\n\n.row {\n    &--editmodebg {\n        background-color: #fff;\n        padding: 0 35px;\n    }\n\n    &--wbg {\n        background-color: #fff;\n    }\n}\n\n.loader-spin {\n    background-color: hsla(0, 0%, 92.5%, .9);\n    position: fixed;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    right: 0;\n}\n\n.loader__inner {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n\n}\n\n#Path_129 {\n    animation: blink 2s linear infinite;\n    opacity: 0;\n}\n\n#Path_130 {\n    animation: blink 2s linear infinite;\n    animation-delay: .5s;\n    opacity: 0;\n}\n\n#Path_132 {\n    animation: blink 2s linear infinite;\n    animation-delay: 1s;\n    opacity: 0;\n}\n\n#Path_131 {\n    animation: blink 2s linear infinite;\n    animation-delay: 1.5s;\n    opacity: 0;\n}\n\n@keyframes blink {\n    0% {\n        opacity: 0;\n    }\n\n    50% {\n        opacity: 1;\n    }\n\n    100% {\n        opacity: 0;\n    }\n\n}","// Shared Challenge Navigator mixins, breakpoints, and variables\n// Import this at the top of each stage component SCSS\n\n@import './../../../assets/styles/variables';\n\n// CN-specific variables\n$cn-border-color: #CFDBE2;\n$cn-edit-bg: #ebebeb;\n$cn-card-bg: #f5f5f5;\n\n// Breakpoints\n$mq-pc: 'only screen and (max-width: 1200px)';\n$mq-md: 'only screen and (max-width: 991px)';\n$mq-sm: 'only screen and (max-width: 767px)';\n$mq-mobile: 'only screen and (max-width: 480px)';\n\n// Mixins\n@mixin fflex() {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n}\n\n@mixin fflex-jcc() {\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n}\n\n@mixin fflex-aic() {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n\n@mixin transition-slow() {\n    -webkit-transition: all ease 0.3s;\n    -o-transition: all ease 0.3s;\n    transition: all ease 0.3s;\n}\n\n@mixin transition-none() {\n    -webkit-transition: none;\n    -o-transition: none;\n    transition: none;\n}\n\n@mixin appearance-none() {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n}\n\n@mixin transRotate($rotate) {\n    -webkit-transform: rotate($rotate);\n    -ms-transform: rotate($rotate);\n    transform: rotate($rotate);\n}\n\n@mixin headingfont() {\n    font-family: $muso-700 !important;\n    font-weight: normal !important;\n}\n\n@mixin contentfont() {\n    font-family: $muso-300 !important;\n    font-weight: normal !important;\n}\n\n// Common element resets\nlabel {\n    font-family: 'Open Sans', sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
